<template>
  <div>
    <div class="container">
      <!-- 左侧导航栏 -->
      <div class="sidebar">
        <ul class="nav">
          <li
            v-for="item in navItems"
            :key="item.id"
            class="nav-item"
            :class="{ active: activeTab === item.id }"
            @click="tablechange(item.id)"
          >
            <img :src="item.img" alt="" class="img-fluid" />
            {{ item.title }}
          </li>
          <!-- <li class="nav-item">
          <img src="@/assets/img/inside.png" alt="" class="img-fluid" />
          订阅中心
        </li>
        <li class="nav-item">
          <img src="@/assets/img/users.png" alt="" class="img-fluid" />账号管理
        </li> -->
        </ul>
      </div>

      <el-main class="newmain">
        <el-tabs
          v-model="activeTab"
          class="tab-container"
          v-if="activeTab == 'subscription' || activeTab == 'second'"
        >
          <el-tab-pane label="新增订阅" name="subscription">
            <el-form :model="form" ref="formRef" :rules="rulem">
              <el-form-item
                label="订阅器名称"
                label-width="120px"
                :required="true"
                prop="subscriberName"
              >
                <el-input
                  v-model="form.subscriberName"
                  placeholder="建议长度2-6个字符"
                  class="newslact"
                ></el-input>
                <span
                  >(用订阅器名称来区别您创建的多个订阅器，例如：交通运输+上海市；
                  创建的订阅器将同步到已订阅信息页面，可对订阅器进行修改和删除)</span
                >
              </el-form-item>
              <el-form-item
                label="选择领域"
                label-width="120px"
                prop="fieldId"
                :required="true"
              >
                <el-select v-model="form.fieldId" placeholder="请选择">
                  <el-option
                    v-for="option in fieldOptions"
                    :key="option.value"
                    :label="option.label"
                    class="newslact"
                    :value="option.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="地区" label-width="120px" prop="districtId">
                <el-select v-model="form.districtId" placeholder="请选择">
                  <el-option
                    class="newslact"
                    v-for="option in regions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-switch
                  v-model="form.whetherMailboxPush"
                  active-value="1"
                  inactive-value="0"
                  active-text="邮件推送"
                  @change="handleChange"
                ></el-switch>
              </el-form-item>
              <el-form-item
                label="邮箱"
                v-if="needemial"
                label-width="120px"
                prop="email"
              >
                <el-input
                  v-model="form.email"
                  placeholder="请输入邮箱"
                  class="newslact"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item>
              <el-switch
                v-model="form.whetherWechatPush"
                active-value="1"
                inactive-value="0"
                active-text="微信接受推送"
              ></el-switch>
            </el-form-item> -->
              <el-form-item>
                <el-button type="primary" @click="save">保存</el-button>
                <!-- <el-button @click="cancel">返回</el-button> -->
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="已订阅信息" name="second" @click="refeash">
            <div>
              <el-form class="newslacts" label-width="100px">
                <el-form-item label="选择订阅器" class="newstion">
                  <el-radio-group
                    v-model="selectedSubscription"
                    class="radio-group"
                    style="width: 594px; height: 57px;"
                  >
                    <el-radio-button
                      style="padding: 5px;"
                      v-for="item in subscriptionOptions"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.label }}
                    </el-radio-button>
                  </el-radio-group>
                  <div class="newdelect">
                    <el-link
                      type="primary"
                      style="margin-right: 10px;"
                      @click="modifyConditions"
                      >修改条件</el-link
                    >
                    <el-link type="danger" @click="deleteSubscription"
                      >删除订阅</el-link
                    >
                  </div>
                </el-form-item>
                <el-form-item class="search-form" v-if="false">
                  <el-input
                    v-model="searchKeyword"
                    placeholder="请输入搜索关键词"
                    style="width: 20%;"
                  ></el-input>
                  <el-button type="primary" @click="search" class="newbutton"
                    >搜索</el-button
                  >
                </el-form-item>
                <div class="threestion" v-if="false">
                  <!-- <el-form-item>
                  <el-select v-model="selectedIndustry" style="width: 150px;" placeholder="选择行业">
                    <el-option
                      v-for="item in industryOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item> -->

                  <!-- 省份选择 -->
                  <el-form-item>
                    <span>省份：</span>
                    <el-select
                      v-model="selectedProvince"
                      style="width: 150px;"
                      placeholder="选择省份"
                    >
                      <el-option
                        v-for="item in regions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>

                  <!-- 时间筛选 -->
                  <el-form-item>
                    <span>其他筛选：</span>
                    <el-select
                      v-model="selectedFilter"
                      style="width: 150px;"
                      placeholder="其他筛选"
                    >
                      <el-option
                        v-for="item in filterOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <div class="data-list-container" v-if="false">
              <div class="header">
                <span class="total">共有{{ totalall }}条数据产品</span>
                <div class="sort-buttons">
                  <el-button type="primary" size="small">按时间排序</el-button>
                  <!-- <el-button size="small" style="margin-left: 10px;"
                  >相关性排序</el-button
                > -->
                </div>
              </div>

              <div class="data-items">
                <div
                  v-for="(item, index) in dataList"
                  :key="index"
                  class="data-item"
                >
                  <div class="item-content">
                    <div class="title">{{ item.productName }}</div>
                    <div class="details">
                      <span>产品类型: {{ item.productType }}</span>
                      <span style="margin-left: 20px;"
                        >行业: {{ item.applicationMinceArea }}</span
                      >
                    </div>
                  </div>
                  <div class="date">{{ item.updateTime }}</div>
                </div>
              </div>

              <div class="pagination-container">
                <el-pagination
                  :current-page.sync="currentPage"
                  :page-size="pageSize"
                  :total="totalall"
                  layout="prev, pager, next, jumper"
                  @current-change="handlePageChange"
                >
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

        <el-tabs
          v-model="activeTabs"
          @tab-click="handleTabClick"
          v-if="activeTab == 'account'"
        >
          <el-tab-pane label="账号信息" name="accountInfo">
            <div class="section">
              <el-form
                :model="userInfo"
                label-width="120px"
                :rules="rulesu"
                ref="userInfoForm"
              >
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="单位名称：" prop="unitname">
                      <el-input v-model="userInfo.unitname"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话：" prop="phonenumber">
                      <el-input v-model="userInfo.phonenumber"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="邮箱：" prop="email">
                      <el-input v-model="userInfo.email"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="微信号：" prop="wechatnumber">
                      <el-input v-model="userInfo.wechatnumber"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="用户名：" prop="nickName">
                      <el-input v-model="userInfo.nickName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="会员等级：" prop="membershiplevel">
                      <el-input
                        v-model="userInfo.membershiplevel"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="到期时间：" prop="expirationdate">
                      <el-input
                        v-model="userInfo.expirationdate"
                        style="width: 200px;"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-button type="primary" @click="editUserInfo"
                  >修改信息</el-button
                >
              </el-form>
            </div>
          </el-tab-pane>

          <el-tab-pane label="修改密码" name="changePassword">
            <div class="section">
              <el-form
                :model="passwordForm"
                :rules="rules"
                ref="passwordFormRef"
                label-width="120px"
              >
                <el-form-item label="原始密码：">
                  <el-input
                    v-model="passwordForm.originalPassword"
                    :type="originalPasswordType"
                    style="width: 850px;"
                    placeholder="请输入您的原始密码"
                  >
                    <template #suffix>
                      <i
                        :class="[
                          'el-icon-view',
                          {
                            'el-icon-view-active':
                              originalPasswordType === 'text',
                          },
                        ]"
                        @click="toggleOriginalPasswordView"
                      ></i>
                    </template>
                  </el-input>
                </el-form-item>

                <el-form-item label="新密码：" prop="newPassword">
                  <el-input
                    v-model="passwordForm.newPassword"
                    :type="newPasswordType"
                    style="width: 850px;"
                    placeholder="8-20个字符"
                  >
                    <template #suffix>
                      <i
                        :class="[
                          'el-icon-view',
                          { 'el-icon-view-active': newPasswordType === 'text' },
                        ]"
                        @click="toggleNewPasswordView"
                      ></i>
                    </template>
                  </el-input>
                </el-form-item>

                <el-form-item label="确认新密码：" prop="confirmPassword">
                  <el-input
                    v-model="passwordForm.confirmPassword"
                    :type="confirmPasswordType"
                    style="width: 850px;"
                    placeholder="再次输入新密码"
                  >
                    <template #suffix>
                      <i
                        :class="[
                          'el-icon-view',
                          {
                            'el-icon-view-active':
                              confirmPasswordType === 'text',
                          },
                        ]"
                        @click="toggleConfirmPasswordView"
                      ></i>
                    </template>
                  </el-input>
                </el-form-item>

                <el-button type="primary" @click="updatePassword"
                  >修改密码</el-button
                >
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="会员管理" name="memberManage">
            <div class="company-info" v-if="Object.keys(overdata).length > 0">
              <div>
                <span>{{ companyName }}</span>
                <el-tag type="success" size="small">{{ qiyetitle }}</el-tag>
                <span class="admin-label">{{ authority }}</span>
              </div>
              <div>
                用户名：{{ userName }}
                <span v-if="qiyetitle != '免费会员' && authority == '管理员'"
                  >已分配用户：{{ allocatedUsers }}/{{ totalUsers }}</span
                >
                <el-button
                  type="primary"
                  size="mini"
                  v-if="qiyetitle != '免费会员' && authority == '管理员'"
                  @click="onAddMember"
                  >+新增成员</el-button
                >
              </div>
              <div>
                <span
                  >账户余额：<el-tag type="info" size="small"
                    >{{ accountBalance }}枚Hi豆</el-tag
                  ></span
                >
                <span>到期时间：{{ expireDate }}</span>
              </div>
              <div class="action-buttons">
                <el-button size="mini" @click="onViewDetails"
                  >消费明细</el-button
                >
                <!-- <el-button size="mini" type="danger" @click="onRenew"
               v-if="qiyetitle != '免费会员'"
                >去续费</el-button
              > -->
                <el-button
                  size="mini"
                  v-if="qiyetitle != '高级会员' && authority == '普通成员'"
                  type="danger"
                  @click="onUpgrade"
                  >去升级</el-button
                >
              </div>
            </div>

            <el-table
              :data="members"
              style="width: 100%;"
              border
              v-if="qiyetitle != '免费会员' && authority == '管理员'"
            >
              <el-table-column prop="userName" label="用户名" width="180" />
              <el-table-column
                prop="phonenNumber"
                label="成员信息"
                width="180"
              />
              <el-table-column prop="authority" label="成员权限" width="120" />
              <el-table-column label="成员额度" width="200">
                <template slot-scope="scope">
                  <span v-if="scope.row.amountt"
                    >{{ scope.row.amountt }}枚</span
                  >
                  <span v-else>--枚</span>
                  <el-button
                    v-if="scope.row.authority != '管理员'"
                    type="text"
                    size="mini"
                    @click="onAdjustQuota(scope.row)"
                    >调整额度</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template
                  slot-scope="scope"
                  v-if="scope.row.authority != '管理员'"
                >
                  <el-button
                    type="text"
                    size="mini"
                    style="color: #f56c6c;"
                    @click="onDelete(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>

            <el-dialog
              title="调整额度"
              :visible.sync="dialogVisiblezhang"
              width="320px"
            >
              <el-input-number
                v-model="adjustAmount"
                :min="0"
                :step="100"
                label="额度"
              />
              <span style="margin-left: 10px;">枚</span>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmAdjust"
                  >确定</el-button
                >
              </div>
            </el-dialog>
          </el-tab-pane>

          <el-tab-pane label="账户安全" name="accountSecurity" v-if="false">
            <div class="section">
              <el-form label-width="120px">
                <el-form-item label="登录设置：">
                  <el-switch
                    v-model="loginSettings.smsLogin"
                    active-text="开启"
                    inactive-text="关闭"
                  ></el-switch>
                  <div v-if="loginSettings.smsLogin">
                    当前未绑定手机号<br />
                    开启后可使用绑定的手机号和验证码登录本账号，可在[账号信息]-[基本信息]中修改绑定手机号
                  </div>
                </el-form-item>
              </el-form>
              <el-table :data="loginRecords" style="width: 100%;">
                <el-table-column prop="action" label="行为"></el-table-column>
                <el-table-column prop="ip" label="IP地址"></el-table-column>
                <el-table-column prop="address" label="地址"></el-table-column>
                <el-table-column
                  prop="browser"
                  label="浏览器"
                ></el-table-column>
                <el-table-column prop="time" label="记录时间"></el-table-column>
              </el-table>
              <el-pagination
                background
                layout="prev, pager, next"
                :total="5"
                :page-size="5"
                @current-change="handlePageChange"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div v-if="activeTab == 'user'" class="biguser">
          <div class="membership-container">
            <div
              v-for="(plan, index) in membershipPlans"
              :key="index"
              class="membership-card"
              :class="plan.type"
            >
              <h2 class="membership-title" :style="{ color: plan.titleColor }">
                {{ plan.title }}
                <span class="discount-tag" v-if="plan.discount">限时折扣</span>
              </h2>

              <div class="membership-subtitle">{{ plan.subtitle }}</div>
              <div class="price-container">
                <span class="price">￥{{ plan.price }}</span>
                <span class="original-price" v-if="plan.originalPrice">{{
                  plan.originalPrice
                }}</span>
              </div>

              <ul class="features" v-if="plan.features && plan.features.length">
                <li v-for="(feature, fIndex) in plan.features" :key="fIndex">
                  {{ feature.text }}
                  <img
                    v-if="feature.hasIcon == 'true'"
                    src="@/assets/img/hidou.png"
                    alt="H1豆图标"
                    class="h1-icon"
                  />
                  <span class="coins-text">{{ feature.coins }}</span>
                </li>
              </ul>
              <div class="description" v-if="plan.description">
                {{ plan.description }}
              </div>
              <div class="action-area">
                <div class="status" v-if="plan.status == '已开通'">
                  {{ plan.status }}
                </div>
                <div class="status" v-if="plan.status == '稍后开通'">
                  {{ plan.status }}
                </div>
                <el-button
                  v-if="plan.status == '未开通'"
                  type="primary"
                  class="red-border-button"
                  @click="subscribe(plan.type, plan.id)"
                >
                  立即开通
                </el-button>
              </div>
            </div>
          </div>
          <div class="membership-service-container">
            <h2 class="table-title">会员服务列表</h2>
            <el-table
              :data="tableData"
              border
              style="width: 100%;"
              :header-cell-style="{ background: '#f5f5f5', fontWeight: 'bold' }"
              :span-method="arraySpanMethod"
              :cell-style="cellStyle"
            >
              <el-table-column
                prop="category"
                label="分类"
                width="100"
                header-align="center"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.showCategory" class="category-cell">
                    {{ scope.row.category }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="service"
                label="服务项目"
                width="180"
              ></el-table-column>
              <el-table-column prop="free" label="免费会员"></el-table-column>
              <el-table-column
                prop="personal"
                label="个人会员"
              ></el-table-column>
              <el-table-column
                prop="enterprise"
                label="企业会员(3个账号)"
              ></el-table-column>
              <el-table-column
                prop="premium"
                label="高级会员(5个账号)"
              ></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="order-payment-container" v-if="activeTab == 'payer'">
          <el-tabs v-model="activeTabm" type="card" v-if="activeTab == 'payer'">
            <el-tab-pane label="我的订单" name="orders">
              <el-table
                :data="orders"
                border
                style="width: 100%;"
                :header-cell-style="{
                  background: '#f5f5f5',
                  fontWeight: 'bold',
                }"
              >
                <el-table-column
                  prop="orderNumber"
                  label="订单编号"
                  width="140"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="enterpriseNum"
                  label="企业/个人名称"
                  width="220"
                ></el-table-column>
                <el-table-column
                  prop="membershipLevel"
                  label="会员等级"
                  width="100"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="termOfMembership"
                  label="会员期限"
                  width="190"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="orderTime"
                  label="下单时间"
                  width="170"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="paymentStatus"
                  label="付款状态"
                  width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      :class="{ unpaid: scope.row.paymentStatus === '1' }"
                      @click="
                        scope.row.paymentStatus === '1'
                          ? handleClick(scope.row)
                          : null
                      "
                    >
                      {{
                        scope.row.paymentStatus === "1"
                          ? "未付款"
                          : scope.row.paymentStatus === "2"
                          ? "已付款"
                          : "未知状态"
                      }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="140" align="center">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.paymentStatus === '2'"
                      type="text"
                      size="small"
                      @click="applyInvoice(scope.row)"
                    >
                      发票申请
                    </el-button>
                    <el-button
                      type="text"
                      size="small"
                      @click="deleteOrder(scope.row)"
                      style="color: #f56c6c;"
                    >
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane label="付款方式" name="payment">
              <div class="payment-content" style="width: 80%;">
                <h3>公司对公汇款账号信息</h3>

                <div class="bank-info">
                  <p><strong>名称：</strong>{{ bigdan.name }}</p>
                  <p>
                    <strong>纳税人识别号：</strong>{{ bigdan.taxIdentifier }}
                  </p>
                  <p><strong>地址：</strong>{{ bigdan.address }}</p>

                  <p><strong>开户行：</strong>{{ bigdan.bankName }}</p>
                  <p><strong>账号：</strong>{{ bigdan.accountNumber }}</p>
                  <p><strong>电话：</strong>{{ bigdan.phone }}</p>
                </div>

                <div class="notice">
                  <h3>特别提示</h3>
                  <ol>
                    <li>
                      请在转账时务必仔细核对转账信息以免造成退工、错工，延误对您的服务
                    </li>
                    <li>支付成功后1个工作日内开通</li>
                    <li>
                      您可在我的订单页面，查询订单状态；可在账号管理-会员管理页面，查看账号使用记录
                    </li>
                    <li>遇到问题或疑问，请及时联系我们。</li>
                  </ol>
                </div>
              </div>

              <div class="payment-content">
                <h3>如需开票，请完善如下信息：</h3>
                <div class="bank-info" style="width: 80%;">
                  <el-form
                    ref="invoiceForm"
                    :model="formData"
                    :rules="rulesk"
                    label-width="120px"
                    class="invoice-form"
                  >
                    <el-form-item label="企业类型：" prop="titleType">
                      <el-radio-group v-model="formData.titleType" @change='clearInvoice'>
                        <el-radio label="企业"
                          >企业</el-radio
                        >
                        <el-radio label="事业单位"
                          >事业单位</el-radio
                        >
                        <el-radio label="个人">个人</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <!-- 发票类型 -->
                    <el-form-item label="发票类型：" prop="invoiceType">
                      <el-select
                        v-model="formData.invoiceType"
                        placeholder="请选择"
                      >
                        <el-option
                        v-if='formData.titleType!="个人"'
                          label="增值税专票(数电专票)"
                          value="增值税专票(数电专票)"
                        ></el-option>
                        <el-option
                          label="普通发票"
                          value="普通发票"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <!-- 发票抬头 -->
                    <el-form-item label="发票抬头：" prop="invoiceTitle">
                      <el-input v-model="formData.invoiceTitle"></el-input>
                    </el-form-item>

                    <!-- 抬头类型 -->

                    <!-- 纳税人识别号 -->
                    <el-form-item label="纳税人识别号："   v-if="formData.invoiceType == '增值税专票(数电专票)'" prop="taxNumber">
                      <el-input
                        v-model="formData.taxNumber"
                        placeholder="请输入15或18位纳税人识别号"
                      ></el-input>
                    </el-form-item>
<el-form-item
                      label="开户银行："
                      v-if="formData.invoiceType == '增值税专票(数电专票)'"
                      prop="companyAddress"
                    >
                      <el-input v-model="formData.depositBank"></el-input>
                    </el-form-item>
                    <!-- 注册地址 -->
                    <el-form-item
                      label="注册地址："
                      v-if="formData.invoiceType == '增值税专票(数电专票)'"
                      prop="companyAddress"
                    >
                      <el-input v-model="formData.companyAddress"></el-input>
                    </el-form-item>

                    <!-- 公司电话 -->
                    <el-form-item
                      label="公司电话："
                      prop="companyPhone"
                      v-if="formData.invoiceType == '增值税专票(数电专票)'"
                      required
                    >
                      <el-input
                        v-model="formData.companyPhone"
                        placeholder="请输入公司电话"
                      ></el-input>
                    </el-form-item>

                    <!-- 银行账号 -->
                    <el-form-item
                      label="银行账号："
                      prop="bankAccount"
                      v-if="formData.invoiceType == '增值税专票(数电专票)'"
                      required
                    >
                      <el-input v-model="formData.bankAccount"></el-input>
                    </el-form-item>

                    <!-- 发票内容 -->
                    <el-form-item label="发票内容："  v-if="formData.invoiceType == '增值税专票(数电专票)'">
                      <el-radio-group v-model="formData.contentType">
                        <el-radio label="detail">明细</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="联系电话：" prop="telPhone">
                      <el-input
                        v-model="formData.telPhone"
                        placeholder="请输入联系电话"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="收票邮箱：" prop="telEmail">
                      <el-input
                        v-model="formData.telEmail"
                        placeholder="请输入收票邮箱"
                      ></el-input>
                    </el-form-item>
                    <!-- 提示信息 -->
                    <div class="notice">
                      我们将在付款后五个工作日内完成开票
                    </div>

                    <!-- 操作按钮 -->
                    <el-form-item class="form-buttons">
                      <el-button
                        type="primary"
                        @click="handleSubmit"
                        :loading="submitting"
                        >提交</el-button
                      >
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-main>

      <el-dialog
        title="新增成员"
        :visible.sync="addMemberVisible"
        width="500px"
        @closed="resetAddMemberForm"
      >
        <el-form
          :model="addMemberForm"
          :rules="addMemberRules"
          ref="addMemberForm"
          label-width="80px"
        >
          <el-form-item label="手机号" prop="username">
            <el-input
              v-model="addMemberForm.username"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="password">
            <div class="verify-code-wrapper">
              <el-input
                v-model="addMemberForm.password"
                placeholder="请输入密码"
              ></el-input>
            </div>
          </el-form-item>
          <!-- <el-form-item prop="code"  label="验证码"      >
          
        <el-input
          v-model="addMemberForm.code"
        
          auto-complete="off"
          placeholder="请输入验证码"
          style="width: 50%"
         
        >
          <template #prefix><svg-icon icon-class="validCode" class="el-input__icon input-icon" /></template>
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" class="login-code-img"/>
        </div>
      </el-form-item> -->
          <!-- <el-divider></el-divider> -->

          <el-form-item label="分配额度" prop="quota">
            <el-input v-model="addMemberForm.quota" placeholder="请输入额度">
              <template slot="append">枚</template>
            </el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="addMemberVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAddMemberForm"
            >提交</el-button
          >
        </div>
      </el-dialog>

      <!-- 消费明细弹框 -->
      <el-dialog
        title="消费明细"
        :visible.sync="consumptionVisible"
        width="900px"
        before-close="handleClosed"
      >
        <div class="filter-bar">
          <el-date-picker
            v-model="queryParams.startTime"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
            :picker-options="startPickerOptions"
            class="date-picker"
          ></el-date-picker>
          <span class="to-text">至</span>
          <el-date-picker
            v-model="queryParams.endTime"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="endPickerOptions"
            class="date-picker"
          ></el-date-picker>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </div>

        <el-table
          :data="tableDataxiao"
          style="width: 100%;"
          border
          v-loading="loading"
        >
          <el-table-column
            prop="userName"
            label="用户名"
            width="150"
          ></el-table-column>
          <el-table-column prop="usageFunction" label="使用功能" width="200">
            <template slot-scope="scope">
              {{
                scope.row.usageFunction == 1
                  ? "买方画像"
                  : scope.row.usageFunction == 2
                  ? "融资建议"
                  : scope.row.usageFunction == 3
                  ? "开发方向"
                  : "未知"
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="consumedHibean"
            label="消耗Hi豆"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="usageTime"
            label="使用时间"
            width="200"
          ></el-table-column>
        </el-table>

        <div class="pagination">
          <span class="total">共{{ total }}条</span>
          <el-pagination
            layout="prev, pager, next, jumper"
            :total="total"
            :page-size="queryParams.pageSize"
            :current-page="queryParams.pageNum"
            @current-change="handlePageChange"
          >
          </el-pagination>
        </div>
      </el-dialog>
      <el-dialog title="修改条件" :visible.sync="dialogVisible">
        <el-form :model="forms" ref="formRefss" :rules="rulem">
          <el-form-item
            label="订阅器名称："
            label-width="140px"
            prop="subscriberName"
            required
          >
            <el-input
              class="newslact"
              v-model="forms.subscriberName"
            ></el-input>
            <span
              >(用订阅器名称来区别您创建的多个订阅器，例如：交通运输+上海市；
              创建的订阅器将同步到已订阅信息页面，可对订阅器进行修改和删除)</span
            >
          </el-form-item>
          <el-form-item
            label="选择领域"
            label-width="120px"
            prop="fieldId"
            :required="true"
          >
            <el-select v-model="forms.fieldId" placeholder="请选择">
              <el-option
                class="newslact"
                v-for="option in fieldOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="地区：" prop="districtId" label-width="120px">
            <el-select v-model="forms.districtId" placeholder="请选择">
              <el-option
                class="newslact"
                v-for="item in regions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-switch
              v-model="forms.whetherMailboxPush"
              active-value="1"
              inactive-value="0"
              active-text="邮件推送"
            ></el-switch>
          </el-form-item>
          <!-- <el-form-item>
          <el-switch
            v-model="forms.whetherWechatPush"
            active-value="1"
            inactive-value="0"
            active-text="微信接受推送"
          ></el-switch>
          <el-link type="danger" @click="unbindWeixin">解除绑定</el-link>
        </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">返回</el-button>
          <el-button type="primary" @click="saves">保存</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="填写企业信息"
        :visible.sync="dialogVisiblexinxi"
        width="800px"
        :before-close="handleClose"
        custom-class="enterprise-dialog"
      >
        <div class="form-container">
          <el-form
            :model="enterpriseForm"
            ref="enterpriseForm"
            :rules="rulesqiye"
            label-width="159px"
            label-position="left"
          >
            <div class="form-row">
              <el-form-item
                label="单位名称："
                prop="companyName"
                class="form-item"
              >
                <el-input
                  v-model="enterpriseForm.companyName"
                  placeholder="请输入单位名称"
                  class="custom-input"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="单位性质："
                prop="unitNature"
                class="form-item"
              >
                <el-select
                  v-model="enterpriseForm.unitNature"
                  placeholder="请选择"
                  class="custom-select"
                >
                  <el-option label="国有企业" value="国有企业"></el-option>
                  <el-option label="民营企业" value="民营企业"></el-option>
                  <el-option label="外资企业" value="外资企业"></el-option>
                  <el-option label="港澳台企业" value="港澳台企业"></el-option>
                  <el-option
                    label="混合所有制企业"
                    value="混合所有制企业"
                  ></el-option>
                  <el-option label="集体企业" value="集体企业"></el-option>
                  <el-option
                    label="其他特殊类型"
                    value="其他特殊类型"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="form-row">
              <el-form-item
                label="行业："
                prop="industryList"
                class="form-item"
              >
                <!-- <el-select
                v-model="enterpriseForm.industry"
                placeholder="请选择"
                class="custom-select"
              >
                <el-option label="互联网" value="internet"></el-option>
                <el-option label="金融" value="finance"></el-option>
                <el-option label="教育" value="education"></el-option>
              </el-select> -->

                <el-cascader
                  v-model="enterpriseForm.industryList"
                  :options="cascaderData"
                  :show-all-levels="false"
                  class="neddselect"
                  :props="{
                    label: 'tradeName',
                    value: 'tradeId',
                    children: 'children',
                  }"
                  placeholder="请选择行业"
                  @change="handleCascaderChange"
                ></el-cascader>
              </el-form-item>

              <el-form-item label="联系地址：" prop="address" class="form-item">
                <el-input
                  v-model="enterpriseForm.address"
                  placeholder="请输入"
                  class="custom-input"
                  style="width: 210px;"
                ></el-input>
              </el-form-item>
            </div>

            <!-- <div class="form-row">
            <el-form-item
              label="主营产品："
              prop="mainProducts"
              class="form-item"
            >
              <el-input
                v-model="enterpriseForm.mainProducts"
                placeholder="请输入"
                class="custom-input"
              ></el-input>
            </el-form-item>

          

            <el-form-item
              label="统一社会信用代码:"
              prop="socialCreditCode"
              class="form-item"
            >
              <el-input
                v-model="enterpriseForm.socialCreditCode"
                placeholder="请输入"
                class="custom-input"
              ></el-input>
            </el-form-item>
          </div> -->

            <div class="form-row">
              <el-form-item
                label="联系人："
                prop="contactPerson"
                class="form-item"
              >
                <el-input
                  v-model="enterpriseForm.contactPerson"
                  placeholder="请输入"
                  class="custom-input"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="联系电话："
                prop="phoneNumber"
                class="form-item"
              >
                <el-input
                  v-model="enterpriseForm.phoneNumber"
                  placeholder="请输入"
                  class="custom-input"
                ></el-input>
              </el-form-item>
            </div>

            <div class="form-row">
              <el-form-item
                label="营业执照："
                class="form-item full-width"
                prop="uploadedImage"
              >
                <el-upload
                  action="https://www.hittik.com/zntop/orderForMemberController/uploadFile"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-success="handleUploadSuccess"
                  :file-list="fileList"
                  class="custom-upload"
                  :headers="uploadHeaders"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </div>

            <!-- <div class="form-row">
            
          </div> -->
          </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisiblexinxi = false" class="cancel-btn"
            >取 消</el-button
          >
          <el-button type="primary" @click="submitForm" class="submit-btn"
            >提 交</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="付款信息"
        :visible.sync="dialogVisiblepay"
        width="1000px"
        :before-close="handleClose"
        custom-class="payment-dialog"
      >
        <div class="payment-container">
          <!-- 提示信息放在最上面 -->
          <div class="payment-tip">
            <span class="tip-number">①</span> 可在付款信息完备后，再进行填写
          </div>
          <!-- 收款账号信息 -->
          <div class="account-and-notice">
            <div class="account-info">
              <h3 class="info-title">收款账号</h3>
              <div class="info-item">
                <span class="info-label">公司名称：</span>
                <span class="info-content">{{ bigdan.name }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">开户行：</span>
                <span class="info-content">{{ bigdan.bankName }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">纳税人识别号：</span>
                <span class="info-content">{{ bigdan.taxIdentifier }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">地址：</span>
                <span class="info-content">{{ bigdan.address }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">账号：</span>
                <span class="info-content">{{ bigdan.accountNumber }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">电话：</span>
                <span class="info-content">{{ bigdan.phone }}</span>
              </div>
            </div>

            <div class="notice-info">
              <h3 class="notice-title">特别提示</h3>
              <ol class="notice-list">
                <li>
                  请在转账时务必仔细核对转账信息以免造成退汇、错汇，延误对您的服务
                </li>
                <li>支付成功后1个工作日内开通</li>
                <li>
                  您可在我的订单页面，查询订单状态；可在账号管理-会员管理页面，查看账号使用记录
                </li>
                <li>遇到问题或疑问，请及时联系我们。</li>
              </ol>
              <div class="contact-service">
                <el-image
                  style="width: 20px; height: 20px;"
                  :src="urlimage"
                  :preview-src-list="urlimageList"
                >
                </el-image>
                <span class="contact-text">联系客服</span>
              </div>
            </div>
          </div>

          <!-- 特别提示 -->

          <!-- 表单部分 -->
          <el-form
            :model="paymentForm"
            ref="paymentForm"
            :rules="rulespay"
            label-width="150px"
            label-position="right"
            class="payment-form"
          >
            <el-form-item
              label="付款单位名称："
              prop="paymentUnitName"
              class="form-item"
            >
              <el-input
                v-model="paymentForm.paymentUnitName"
                placeholder="请输入"
                class="custom-input"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="付款单位账号："
              prop="paymentUnitAccountNumber"
              class="form-item"
            >
              <el-input
                v-model="paymentForm.paymentUnitAccountNumber"
                placeholder="请输入"
                class="custom-input"
              ></el-input>
            </el-form-item>

            <el-form-item label="汇款单号：" class="form-item">
              <template #label>
                <el-tooltip
                  content="在银行回单（纸质或电子版）的显著位置，通常标注为“流水号”“交易号”或“参考号”"
                  placement="top"
                >
                  <span>汇款单号：</span>
                </el-tooltip>
              </template>
              <el-input
                v-model="paymentForm.receivingAccountNumber"
                placeholder="请输入"
                class="custom-input"
              ></el-input>
              <el-image
                style="width: 60px; height: 46;"
                :src="srcurl"
                :preview-src-list="srcList"
              >
              </el-image>
              <div class="example-text">汇款单号示例</div>
            </el-form-item>
          </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisiblepay = false" class="cancel-btn"
            >取 消</el-button
          >
          <el-button type="primary" @click="submitFormpay" class="submit-btn"
            >提 交</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="发票申请"
        :visible.sync="dialogVisiblefa"
        width="900px"
        @before-close="handleClose"
      >
        <el-form
          ref="invoiceForm"
          :model="formfa"
          :rules="rulesfa"
          label-width="110px"
          class="two-column-form"
          label-position="right"
        >
          <el-form-item label="发票类型：" prop="invoiceType">
            <el-select
              v-model="formfa.invoiceType"
              placeholder="请选择"
              style="width: 100%;"
            >
              <el-option label="增值税发票" value="增值税发票"></el-option>
              <el-option label="普通发票" value="普通发票"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="抬头类型：" prop="headerType">
            <el-radio-group v-model="formfa.headerType">
              <el-radio label="企业或事业单位">企业或事业单位</el-radio>
              <el-radio label="个人">个人</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发票抬头：" prop="invoiceTitle">
            <el-input
              v-model="formfa.invoiceTitle"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="税号："
            prop="taxNumber"
            v-if="form.headerType === 'enterprise'"
            key="taxNumber"
          >
            <el-input
              v-model="formfa.taxNumber"
              placeholder="请输入15-20位税号"
            ></el-input>
          </el-form-item>

          <el-form-item label="发票内容：" prop="invoiceContent">
            <el-radio-group v-model="formfa.invoiceContent">
              <el-radio label="明细">明细</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisiblefa = false">取 消</el-button>
          <el-button type="primary" @click="handleSubmitfa">提 交</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="开通个人会员"
        :visible.sync="payVisible"
        width="50%"
        :before-close="handleCloseDialog"
        custom-class="payment-dialog"
      >
        <!-- 订单详情 -->

        <div class="order-detail">
          <div><p class="newstions">订单详情</p></div>
          <div class="orders-detail">
            <p>开通服务：个人会员</p>
            <p>开通周期：1年</p>
            <p>到期时间：{{ needDate }}</p>
            <p>开通账号：{{ needPhonenumber }}</p>
            <p>支付金额：¥299</p>
          </div>
        </div>

        <div class="payment-container">
          <!-- 主卡片容器 -->
          <div class="payment-card">
            <!-- 二维码区域 -->
            <div class="qrcode-box" ref="qrcodeContainer"></div>

            <!-- 信息内容区 -->
            <div class="info-section">
              <!-- 标题行（带红色对勾） -->
              <div class="title-row">
                <img src="@/assets/img/unuser.png" class="title-img" alt="" />
                <span class="title-tag">个人会员</span>
                <span class="title-text">扫码支付</span>
              </div>

              <!-- 实付信息行 -->
              <div class="pay-info">
                <span class="pay-label">实付：</span>
                <span class="pay-amount">¥299</span>
                <div class="pay-method">
                  <img src="@/assets/img/wxpay.png" class="title-imgs" alt="" />
                  <span>微信扫码支付</span>
                </div>
              </div>

              <!-- 倒计时提示 -->
              <div class="countdown">
                距离订单过期还有 2小时，过期后请重新发起支付
              </div>

              <!-- 协议提示 -->
              <div class="agreement">
                购买前请阅读
                <a  @click="getpdfListData" class="agreement-link">
                  《HITTIK数据资产智脑线上购买协议》
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- 协议勾选区 -->

        <!-- 支付按钮区 -->
      </el-dialog>

      <el-dialog :visible.sync="pdfDialogVisible" title="协议声明" width="80%">
      <!-- 使用 iframe 嵌入 PDF 文件 -->
      <iframe
        v-if="pdfDialogVisible"
        :src="pdfUrl"
        width="100%"
        height="650px"
        frameborder="0"
      ></iframe>
    </el-dialog>
    </div>
    <component :is="currentComponent[currentIndex]"></component>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import CryptoJS from "crypto-js";
import CoreItemOne from "../core_competence/CoreItemOne.vue";
export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      }
      const reg = /^1[3-9]\d{9}$/;
      if (!reg.test(value)) {
        return callback(new Error("请输入正确的手机号"));
      }
      callback();
    };

    // 验证码验证规则
    const validatepassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入密码"));
      }
      // 密码规则示例：长度8-20位，包含数字、字母或特殊符号
      const reg = /^[\w~!@#$%^&*()_+`\-={}:";'<>?,.\/]{8,20}$/;
      if (!reg.test(value)) {
        return callback(
          new Error("密码长度需为8-20位，且只能包含数字、字母和特殊符号")
        );
      }
      callback();
    };

    // 额度验证规则
    const validateQuota = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入分配额度"));
      }
      const reg = /^\d+(\.\d{1,2})?$/;
      if (!reg.test(value)) {
        return callback(new Error("请输入正确的数字，最多两位小数"));
      }
      if (value <= 0) {
        return callback(new Error("额度必须大于0"));
      }
      callback();
    };
    return {
      qrcode: null,
      qrcodeImg: null,
      addMemberVisible: false,
      currentIndex: 0,
      currentComponent: [CoreItemOne],
      currentDate: new Date(),
  pdfDialogVisible: false, // 控制弹框显示
      addMemberForm: {
        username: "",
        password: "",
        quota: "",
        // code:'',
        // uuid: ''
      },
      needPhonenumber: "",
      needDate: "",
      encodeFactor: "u5Ak3Y6Vn2p8L9qZ",
      cascaderData: [], // 级联选择器的数据
      fileList: [],
      authority: "",
      companyId: "",
      addMemberRules: {
        username: [{ validator: validatePhone, trigger: "submit" }],
        password: [{ validator: validatepassword, trigger: "submit" }],
        quota: [{ validator: validateQuota, trigger: "submit" }],
      },
      isCountingDown: false,
      countdown: 0,
      countdownTimer: null,

      // 消费明细弹框相关数据
      consumptionVisible: false,
      loading: false,
      queryParams: {
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 6,
      },
      total: 24,
      tableDataxiao: [],
      functionMap: {
        1: "买房画像",
        2: "融资建议",
      },
      startPickerOptions: {
        disabledDate: (time) => {
          // 开始时间不能晚于结束时间，且不能选择未来的时间
          return (
            time.getTime() > Date.now() ||
            (this.queryParams.endTime &&
              time.getTime() > new Date(this.queryParams.endTime).getTime())
          );
        },
      },
      endPickerOptions: {
        disabledDate: (time) => {
          // 结束时间不能早于开始时间，且不能选择未来的时间
          return (
            time.getTime() > Date.now() ||
            (this.queryParams.startTime &&
              time.getTime() < new Date(this.queryParams.startTime).getTime())
          );
        },
      },
      bigdan: {
        accountNumber: "",
        address: "",
        bankName: "",
        name: "",
        phone: "",
        taxIdentifier: "",
      },
      verifyCode: "",
      quota: "",
      qiyetitle: "",
      companyName: "",
      userName: "",
      allocatedUsers: 2,
      totalUsers: 3,
      accountBalance: 0,
      expireDate: "",
      members: [],
      dialogVisiblezhang: false,
      payVisible: false,
      adjustAmount: 100,
      currentAdjustIndex: null,
      dialogVisiblefa: false,
      formfa: {
        invoiceType: "",
        invoiceTitle: "",
        headerType: "",
        taxNumber: "",
        invoiceContent: "",
      },
      submitting: false,
      formData: {
        invoiceType: "",
        invoiceTitle: "",
        titleType: "个人",
        taxNumber: "",
        companyAddress: "",
        depositBank:'',
        companyPhone: "",
        bankAccount: "",
        telEmail: "",
        telPhone: "",
        contentType: "detail",
      },
      rulesk: {
        titleType: [
          { required: true, message: "请选择企业类型", trigger: "change" },
        ],
        invoiceType: [
          { required: true, message: "请选择发票类型", trigger: "change" },
        ],
        invoiceTitle: [
          { required: true, message: "请输入发票抬头", trigger: "blur" },
        ],
        taxNumber: [
          { required: true, message: "请输入纳税人识别号", trigger: "blur" },
          {
            pattern: /^\d{15}(\d{3})?$/,
            message: "请输入15或18位数字",
            trigger: "blur",
          },
        ],
        companyAddress: [
          { required: true, message: "请输入注册地址", trigger: "blur" },
        ],
        depositBank : [
          { required: true, message: "请输入银行开户行", trigger: "blur" },
        ],
        companyPhone: [
          { required: true, message: "请输入公司电话", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入有效的手机号",
            trigger: "blur",
          },
        ],
        telEmail: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: "邮箱格式不正确",
            trigger: "blur",
          },
        ],
        telPhone: [
          { required: true, message: "请输入公司电话", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入有效的手机号",
            trigger: "blur",
          },
        ],
        bankAccount: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
        ],
      },

      rulesfa: {
        invoiceType: [
          { required: true, message: "请选择发票类型", trigger: "change" },
        ],
        headerType: [
          { required: true, validator: "请输入抬头类型", trigger: "change" },
        ],
        invoiceContent: [
          { required: true, message: "请选择发票内容", trigger: "change" },
        ],
      },

      rulespay: {
        paymentUnitName: [
          { required: true, message: "请填写付款单位名称", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在2到50个字符之间",
            trigger: "blur",
          },
        ],
        // paymentUnitAccountNumber: [
        //   { required: true, message: "请填写付款单位账号", trigger: "blur" },
        //   {
        //     pattern: /^\d{16,19}$/,
        //     message: "付款单位账号必须为16到19位数字",
        //     trigger: "blur",
        //   },
        // ],
        receivingAccountNumber: [
          { required: true, message: "请填写汇款单号", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]{10,20}$/,
            message: "汇款单号应为10到20位字母或数字",
            trigger: "blur",
          },
        ],
      },
      paymentForm: {
        paymentUnitName: "",
        paymentUnitAccountNumber: "",
        receivingAccountNumber: "",
      },
      needlevel: "",
      dialogVisiblepay: false,
      rulesqiye: {
        companyName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在2到50个字符之间",
            trigger: "blur",
          },
        ],
        unitNature: [
          { required: true, message: "请选择单位性质", trigger: "change" },
        ],
        industryList: [
          { required: true, message: "请选择行业", trigger: "change" },
        ],
        unitType: [
          { required: true, message: "请选择单位类型", trigger: "change" },
        ],
        mainProducts: [
          { required: true, message: "请输入主营产品", trigger: "blur" },
          {
            min: 2,
            max: 30,
            message: "长度在2到30个字符之间",
            trigger: "blur",
          },
        ],
        mainCustomerGroup: [
          { required: true, message: "请输入主要客户群体", trigger: "blur" },
          {
            min: 2,
            max: 30,
            message: "长度在2到30个字符之间",
            trigger: "blur",
          },
        ],
        contactPerson: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在2到20个字符之间",
            trigger: "blur",
          },
        ],
        phoneNumber: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入有效的手机号",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "请输入联系地址", trigger: "blur" },
        ],
        socialCreditCode: [
          { required: true, message: "请输入社会信用代码", trigger: "blur" },
          {
            pattern: /^[A-Z0-9]{18}$/,
            message: "请输入有效的社会信用代码",
            trigger: "blur",
          },
        ],
        // uploadedImage: [
        //   { required: true, message: '请上传营业执照', trigger: 'change' }
        // ]
      },
      orders: [],

      tableData: [],
      membershipPlans: [],
      activeTabs: "accountInfo",
      activeTabm: "orders",
      uploadHeaders: {
        Authorization: "Bearer " + localStorage.getItem("token"), // 这里换成你的token格式
        // 或者其他你接口需要的头，比如 'token': 'xxx-xxx-token'
      },
      needtiao: "",
      currentDate: this.formatDate(new Date()), // 获取当前日期并格式化
      userInfo: {
        unitname: "",
        phonenumber: "",
        email: "",
        wechatnumber: "",
        nickName: "",
        membershiplevel: "",
        expirationdate: "",
      },
      originalPasswordType: "password", // 原始密码的类型
      newPasswordType: "password", // 新密码的类型
      confirmPasswordType: "password", // 确认密码的类型
      passwordForm: {
        originalPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      loginSettings: {
        smsLogin: false,
      },
      timer: null,
      needemial: false,
      totalall: 0,
      rulem: {
        subscriberName: [
          { required: true, message: "请输入订阅器名称", trigger: "blur" },
          {
            pattern: /^.{0,6}$/,
            message: "订阅器名称最多为6个字符",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: "邮箱格式不正确",
            trigger: "blur",
          },
        ],
        fieldId: [{ required: true, message: "请选择领域", trigger: "change" }],
        // districtId: [
        //   { required: true, message: "请选择地区", trigger: "change" },
        // ],
      },
      agreementChecked: false,
      rulesu: {
        phonenumber: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: "邮箱格式不正确",
            trigger: "blur",
          },
        ],
        // 其他字段的验证规则可以在这里添加
      },
      rules: {
        originalPassword: [
          { required: true, message: "请输入原始密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 8,
            max: 20,
            message: "密码长度必须在8到20个字符之间",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.passwordForm.newPassword) {
                callback(new Error("两次输入的密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      srcList: [],
      urlimageList: [],
      urlimage: "",
      srcurl: "",
      loginRecords: [
        {
          action: "用户登录",
          ip: "139.227.63.111",
          address: "上海-上海",
          browser: "Edge",
          time: "2024-12-19 16:48:35",
        },
        {
          action: "用户登录",
          ip: "139.227.63.111",
          address: "上海-上海",
          browser: "Edge",
          time: "2024-12-09 11:18:37",
        },
        {
          action: "用户登录",
          ip: "139.226.63.104",
          address: "上海-上海",
          browser: "Edge",
          time: "2024-02-26 14:05:31",
        },
        {
          action: "用户登录",
          ip: "223.166.104.162",
          address: "null-null",
          browser: "Edge",
          time: "2023-07-10 14:11:32",
        },
        {
          action: "用户登录",
          ip: "223.166.104.89",
          address: "null-null",
          browser: "Edge",
          time: "2023-05-11 15:18:02",
        },
      ],
      fieldOptions: [],
      totalProducts: 124,
      pageSize: 4, // 每页显示4个卡片
      currentPage: 1,

      options: [
        {
          value: "土建城规",
          label: "土建城规",
          children: [
            {
              value: "城市规划",
              label: "城市规划",
            },
            // 其他子选项
          ],
        },
      ],
      activeTab: "subscription", // 默认激活项
      selectedSubscriptions: ["城市服务"],
      searchKeyword: "",
      selectedIndustry: "",
      selectedProvince: 101,
      other筛选: "近一个月",
      selectedSubscription: "", // 默认选中项的值
      subscriptionOptions: [],

      selectedFilter: "",
      allSeletdata: [],
      // 行业选项数据
      industryOptions: [
        { label: "公共交通", value: "公共交通" },
        { label: "市场营销", value: "市场营销" },
      ],

      // 省份选项数据
      provinceOptions: [
        { label: "北京市", value: "北京市" },
        { label: "天津市", value: "天津市" },
        { label: "河北省", value: "河北省" },
        { label: "山西省", value: "山西省" },
        { label: "内蒙古自治区", value: "内蒙古自治区" },
        { label: "辽宁省", value: "辽宁省" },
        { label: "吉林省", value: "吉林省" },
        { label: "黑龙江省", value: "黑龙江省" },
        { label: "上海市", value: "上海市" },
        { label: "江苏省", value: "江苏省" },
        { label: "浙江省", value: "浙江省" },
        { label: "安徽省", value: "安徽省" },
        { label: "福建省", value: "福建省" },
        { label: "江西省", value: "江西省" },
        { label: "山东省", value: "山东省" },
        { label: "河南省", value: "河南省" },
        { label: "湖北省", value: "湖北省" },
        { label: "湖南省", value: "湖南省" },
        { label: "广东省", value: "广东省" },
        { label: "广西壮族自治区", value: "广西壮族自治区" },
        { label: "海南省", value: "海南省" },
        { label: "重庆市", value: "重庆市" },
        { label: "四川省", value: "四川省" },
        { label: "贵州省", value: "贵州省" },
        { label: "云南省", value: "云南省" },
        { label: "西藏自治区", value: "西藏自治区" },
        { label: "陕西省", value: "陕西省" },
        { label: "甘肃省", value: "甘肃省" },
        { label: "青海省", value: "青海省" },
        { label: "宁夏回族自治区", value: "宁夏回族自治区" },
        { label: "新疆维吾尔自治区", value: "新疆维吾尔自治区" },
        { label: "台湾省", value: "台湾省" },
        { label: "香港特别行政区", value: "香港特别行政区" },
        { label: "澳门特别行政区", value: "澳门特别行政区" },
      ],

      // 筛选条件数据
      filterOptions: [{ label: "近一个月", value: "1" }],
      paginatedData: [
        {
          name: "基于大模型应用技术的客运数据分析系统",
          type: "数据应用",
          industry: "公共交通",
          date: "2024-11-20",
        },
        {
          name: "一种新型的智慧公交系统",
          type: "数据应用",
          industry: "公共交通",
          date: "2024-11-20",
        },
        {
          name: "全平台车联网大数据平台",
          type: "数据应用",
          industry: "公共交通",
          date: "2024-11-20",
        },
        {
          name: "车辆实时监控系统",
          type: "数据应用",
          industry: "公共交通",
          date: "2024-11-20",
        },
      ],

      navItems: [
        {
          id: "subscription",
          title: "订阅中心",
          img: require("@/assets/img/inside.png"), // 使用 require 确保路径正确
        },
        {
          id: "account",
          title: "账号管理",
          img: require("@/assets/img/users.png"),
        },
        {
          id: "user",
          title: "会员中心",
          img: require("@/assets/img/userinter.png"),
        },
        {
          id: "payer",
          title: "订单中心",
          img: require("@/assets/img/payer.png"),
        },
      ],
      planid: null,

      form: {
        subscriberName: "",
        fieldId: "",
        districtId: "",
        whetherMailboxPush: "0",
        whetherWechatPush: "0",
        email: "",
      },
      dialogVisible: false,
      dialogVisiblexinxi: false,
      enterpriseForm: {
        companyName: "",
        industryList: [],
        mainProducts: "",
        contactPerson: "",
        address: "",
        unitNature: "",
        unitType: "",
        mainCustomerGroup: "",
        phoneNumber: "",
        socialCreditCode: "",
        uploadedImage: "",
      },
      overdata: {},
      forms: {
        subscriberName: "",
        fieldId: "",
        districtId: "",
        whetherMailboxPush: "0",
        whetherWechatPush: "0",
      },
      codeUrl: "",
      formLabelWidth: "120px",
      pdfUrl: "",
      captchaEnabled: true,
       debounceTimer: null,
      fields: [
        { label: "土建城规", value: "土建城规" },
        { label: "城市规划", value: "城市规划" },
        // 其他领域选项
      ],
      regions: [
        // 其他地区选项
      ],

      dataList: [],

      goToPage: 1,
    };
  },
  computed: {
    tableDataWithFunctionText() {
      return this.tableDataxiao.map((item) => ({
        ...item,
        usageFunctionText: this.functionMap[item.usageFunction] || "未知功能",
      }));
    },
  },
  methods: {
    clearInvoice(){
this.formData.invoiceType=''
    },
     extractUrls(images) {
      return images.map((img) => {
        const urlMatch = img.match(/<url.*?>(.*?)<\/url>/);
        return urlMatch ? urlMatch[1].trim() : img;
      });
    },
    async getpdfListData() {
      this.pdfDialogVisible = true;
      // const token = localStorage.getItem("token");
      // let config = {};
      // if (token) {
      //   config = {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //     },
      //   };
      // }

       this.$api
                .getTitle()
                .then((responses) => {
                  if (responses) {
                    //console.log(response.data);
                    const newdata = responses;
      this.pdfUrl = this.extractUrls(newdata.membershipagreement);
                  }
                });
      // const res = await this.axios.get(
      //   "https://www.hittik.com/zntop/top/getTitle",
      //   config
      // );
      
    },
    decrypt(text, key) {
      try {
        const keyHex = CryptoJS.enc.Utf8.parse(key);
        const decrypted = CryptoJS.AES.decrypt(text, keyHex, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
      } catch (error) {
        console.error("解密失败:", error);
        return null;
      }
    },
    encrypt(txt) {
      var key = CryptoJS.enc.Utf8.parse(this.encodeFactor);
      var srcs = CryptoJS.enc.Utf8.parse(txt);
      var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString();
    },
    async generateWechatQR(codeUrl) {
       this.qrcodeContent = '';
      //  const container = document.getElementById('qrcode-container');
      this.$refs.qrcodeContainer.innerHTML = "";
 this.$nextTick(() => {
      this.qrcode = new QRCode(this.$refs.qrcodeContainer, {
        text: codeUrl,
        width: 140,
        height: 140,
        colorDark: "#000000",
        colorLight: "#ffffff",
      });

    })
      // this.qrcode = new QRCode(container, {

      // });
    },
    getCode() {
      this.axios
        .get("https://www.hittik.com/code")
        .then((res) => {
          const data = res.data;
          this.captchaEnabled =
            data.captchaEnabled !== undefined ? data.captchaEnabled : true;
          if (this.captchaEnabled) {
            this.codeUrl = "data:image/gif;base64," + data.img;
            this.addMemberForm.uuid = data.uuid;
          }
        })
        .catch((err) => {
          console.error("获取验证码失败:", err);
        });
    },
    async handleTabClick(tab) {
      if (tab.name === "memberManage") {
        // 你当前点击的是“账号信息”页签
        //console.log("切换到了账号信息页签");

        const id = localStorage.getItem("userId");

        // const response = await this.axios.get(
        //   `https://www.hittik.com/zntop/MemberCenter/selectAccount?userId=${id}`,
        //   config
        // );
        this.$api
          .selectAccount({
            userId: id,
          })
          .then((response) => {
            if (response) {
              console.log(response);
              this.overdata = response;
              this.userName = this.overdata.userName;

              this.accountBalance = this.overdata.amount;
              this.authority = this.overdata.authority;
              this.expireDate = this.overdata.times;
              this.companyId = this.overdata.companyId;
              // this.membershipPlans=needdata.membershipPlans
              this.qiyetitle = this.overdata.title;
              this.allocatedUsers = this.overdata.fenZi;
              this.totalUsers = this.overdata.fenMu;
              this.companyName = this.overdata.companyName;
              this.$api
                .selectCompanyList({
                  userId: id,
                })
                .then((responses) => {
                  if (responses) {
                    //console.log(response.data);
                    if (this.qiyetitle != "免费会员") {
                      this.members = responses;
                    }
                  }
                });
            }
          });
      }
    },
    resetAddMemberForm() {
      this.$refs.addMemberForm?.resetFields();
      this.isCountingDown = false;
      this.countdown = 0;
    },
    handlePageChange(page) {
      this.queryParams.pageNum = page;
      this.handleQuery();
    },
    handleQuery() {
      this.loading = true;
      // 模拟API请求
      this.onViewDetails();
      this.loading = false;
    },
    onAddMember() {
      this.addMemberVisible = true;
      this.getCode();
    },
    async onViewDetails() {
      let userid = localStorage.getItem("userId");

      const newData = { userid: userid, ...this.queryParams };

      if (this.queryParams.startTime !== "") {
        newData.startTime = `${this.queryParams.startTime} 00:00:00`;
      } else {
        newData.startTime = ""; // 保持为空字符串
      }

      if (this.queryParams.endTime !== "") {
        newData.endTime = `${this.queryParams.endTime} 00:00:00`;
      } else {
        newData.endTime = ""; // 保持为空字符串
      }

      this.$api.getConsumerDetails(newData).then((response) => {
        if (response) {
          this.consumptionVisible = true;
          let needdata = response.data.list;

          this.total = response.data.total;
          this.tableDataxiao = needdata;
        }
      });
    },
    async getCardListDatas() {
      this.$api
        .getSection({
          parentId: 0,
        })
        .then((responses) => {
          if (responses) {
            //console.log(response.data);
            // const newsList = responses.data.area;
          }
        });
      this.$api
        .getDictionary({
          parentId: 0,
        })
        .then((responses) => {
          if (responses) {
            console.log(responses.data);
            const cascaderData = this.transformData(responses);
            this.cascaderData = cascaderData;
          }
        });
    },
    onRenew() {
      this.tablechange("user");
    },
    transformData(data) {
      return data.map((item) => {
        const { tradeName, tradeId, children } = item;
        const result = {
          tradeName,
          tradeId,
        };
        if (children && children.length > 0) {
          result.children = this.transformData(children);
        }
        return result;
      });
    },
    onUpgrade() {
      this.tablechange("user");
    },
    onAdjustQuota(row) {
      // if(row.quota === "--") {
      //   this.$message.warning("管理员无法调整额度");
      //   return;
      // }
      //console.log(row);

      this.currentAdjustIndex = this.members.indexOf(row);
      this.adjustAmount = row.amountt;
      this.dialogVisiblezhang = true;
      this.needtiao = row.userId;
    },
    async confirmAdjust() {
      if (this.currentAdjustIndex !== null) {
        this.members[this.currentAdjustIndex].quota = this.adjustAmount;

        const userId = localStorage.getItem("userId");

        const id = this.needtiao;

        this.$api
          .updateAmount({
            userIds: id,
            userId: userId,
            amount: this.adjustAmount,
          })
          .then((responses) => {
            if (responses) {
              //console.log(response.data);
              this.dialogVisiblezhang = false;
              let daa = { name: "memberManage" };
              this.handleTabClick(daa);
            } else {
              this.$message.error(responses);
            }
          });
        //       const response = await this.axios.get(
        //         `https://www.hittik.com/zntop/MemberCenter/updateAmount?userIds=${id}&&userId=${userId}
        // &&amount=${this.adjustAmount}`,
        //         config
        //       );
        //       if (response.data.code === 200) {
        //         this.dialogVisiblezhang = false;
        //         let daa = { name: "memberManage" };
        //         this.handleTabClick(daa);
        //       } else {
        //         this.$message.error(response.data.msg);
        //       }
      }
      // //console.log( this.members[this.currentAdjustIndex].quota);
      // this.dialogVisiblezhang = false;
      // this.currentAdjustIndex = null;
    },
    onDelete(index) {
      this.$confirm("确定删除该成员吗？", "提示", {
        type: "warning",
      }).then(async () => {
        const userId = localStorage.getItem("userId");

        this.$api
          .deleteCompany({
            userIds: index.userId,
            userId: userId,
            cId: this.companyId,
          })
          .then((responses) => {
            if (responses) {
              this.$message.success("删除成功");
              let daa = { name: "memberManage" };
              this.handleTabClick(daa);
            }
          });
      });
      // .catch(() => {});
    },
    handleSubmitfa() {
      this.$refs.invoiceForm.validate(async (valid) => {
        if (valid) {
          this.$api
            .insertOrderForInvoiceApplication(this.formfa)
            .then((response) => {
              if (response) {
                this.$message.success("提交成功");
                this.dialogVisiblefa = false;
              }
            });
          // const response = await this.axios.post(
          //   `https://www.hittik.com/`,
          //   this.formfa,
          //   config
          // );
          // if (response.data.code === 200) {
          //   //console.log(response.data);
          //   this.$message.success("提交成功");
          //   this.dialogVisiblefa = false;
          //   // this.membershipPlans=needdata.membershipPlans
          // }
        } else {
          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    submitFormpay() {
      this.$refs.paymentForm.validate(async (valid) => {
        if (valid) {
          //console.log("提交表单:", this.paymentForm);
          // const token = localStorage.getItem("token");
          const userId = localStorage.getItem("userId");
          let datas = {
            userId: userId,
            standby: this.needlevel,
            ...this.paymentForm,
          };
          // const config = {
          //   headers: {
          //     Authorization: `Bearer ${token}`,
          //   },
          // };

          this.$api.insertMyPaymentVoInfo(datas).then((response) => {
            if (response) {
              this.paymentForm = {
                paymentUnitName: "",
                paymentUnitAccountNumber: "",
                receivingAccountNumber: "",
              };
            }
          });
          // const response = await this.axios.post(
          //   `https://www.hittik.com/zntop/orderForMemberController/insertMyPaymentVoInfo`,
          //   datas,
          //   config
          // );
          // if (response.data.code === 200) {

          //   this.paymentForm = {
          //     paymentUnitName: "",
          //     paymentUnitAccountNumber: "",
          //     receivingAccountNumber: "",
          //   };

          // }
          // let ids = {
          //   userid: Number(userId),
          //   memberId: this.planid,
          // };
          this.$api
            .selectOrderCompanyInfo({
              userId: userId,
            })
            .then((responses) => {
              if (responses) {
                //console.log(response.data);
                this.enterpriseForm = responses[0];
                this.dialogVisiblepay = false;
                this.$message.success("提交成功");
                this.tablechange("payer");
                this.activeTabm = "payment";
              }
            });
          // const responsem0 = await this.axios.get(
          //   `https://www.hittik.com/zntop/orderForMemberController/selectOrderCompanyInfo?userId=${userId}`,

          //   config
          // );
          // if (responsem0.data.code === 200) {
          //   if (responsem0.data.data.length > 0) {
          //     this.enterpriseForm = responsem0.data.data[0];

          //     this.dialogVisiblepay = false;

          //     this.$message.success("提交成功");
          //   } else {
          //   }

          //   let needdata = {
          //     userId: userId,
          //     company: this.enterpriseForm.id,
          //     amount: 0,
          //   };
          //   const responsemo = await this.axios.post(
          //   `https://www.hittik.com/zntop/orderForMemberController/insertOrderCompanyInfoIn?`,
          //   needdata,
          //   config
          // );
          // if (responsemo.data.code === 200) {
          // } else {
          // }
        } else {
          this.$message.warning("请填写完整信息");
          return false;
        }
      });
    },

    getneeddata() {
      const userId = localStorage.getItem("userId");
      let datas = {
        userId: userId,
      };
      this.$api.getInvoiceInfo(datas).then((response) => {
        if (response.length > 0) {
          console.log(response);
          this.formData = response[0];
          // this.$message.success("保存成功");
        }
      });
    },

    handleSubmit() {
      this.$refs.invoiceForm.validate(async (valid) => {
        if (valid) {
          const userId = localStorage.getItem("userId");
          let datas = {
            userId: userId,
            ...this.formData,
          };
          this.$api.insertInvoiceInfo(datas).then((response) => {
            if (response) {
              this.$message.success("保存成功");
              this.getneeddata();
            }
          });
        } else {
          this.$message.warning("请填写完整信息");
          return false;
        }
      });
    },
    handleCloseDialog(done) {
      // 这里可以添加关闭前的确认逻辑

      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          // 如果有二维码
          this.qrcode = null;
          this.payVisible = false;
          this.stopPolling();
        })
        .catch((_) => {});

      // 例如：确认用户是否要取消支付
    },

    submitForm() {
      this.$refs.enterpriseForm.validate(async (valid) => {
        if (valid) {
          //console.log("提交表单:", this.enterpriseForm);

          const token = localStorage.getItem("token");
          const userId = localStorage.getItem("userId");
          let bigger = this.enterpriseForm.companyName;
          console.log(this.enterpriseForm.uploadedImage)
           if(this.enterpriseForm.uploadedImage.length==0){
          this.enterpriseForm.uploadedImage=''
          }
          let datas = {
            userId: userId,
            ...this.enterpriseForm,
          };
         
          const config = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };

          this.$api.insertOrderCompanyInfo(datas).then((response) => {
            if (response) {
              this.$message.success("提交成功");
              this.enterpriseForm = {
                companyName: "",
                industryList: "",
                mainProducts: "",
                contactPerson: "",
                address: "",
                unitNature: "",
                unitType: "",
                mainCustomerGroup: "",
                phoneNumber: "",
                socialCreditCode: "",
              };
              this.dialogVisiblexinxi = false;
              this.dialogVisiblepay = true;
              this.$api.selectMyExampleOfPaymentInformation().then((datas) => {
                console.log(datas);
                if (datas.length > 0) {
                  this.bigdan = datas[0];
                } else {
                }
              });
              let objs = {
                userId: userId,
                membershipLevel: this.needlevel,
                enterpriseNum: bigger,
              };

              this.$api.insertMyOrderVoInfo(objs).then((response) => {
                if (response) {
                }
              });

              let obj = {
                userId: userId,
                standby: this.needlevel,
              };

              this.$api.selectMyPaymentVoInfo(obj).then((response) => {
                if (response) {
                  this.paymentForm = response;
                }
              });

              this.$api.getTitle().then((responses) => {
                if (responses) {
                  //console.log(response.data);
                  const newdata = responses.enterprisePicture;
                  this.srcList = newdata[0]
                    .split(",")
                    .map((item) => item.trim())
                    .reverse();
                  this.srcurl = this.srcList[0];

                  const newdatatwo = responses.enterpriseQrCode;
                  const overdata = newdatatwo[0]
                    .split(",")
                    .map((item) => item.trim());
                  this.urlimageList = [overdata[0]];
                  this.urlimage = overdata[1];
                }
              });
            }
          });
          // const response = await this.axios.post(
          //   `https://www.hittik.com/zntop/orderForMemberController/insertOrderCompanyInfo`,
          //   datas,
          //   config
          // );
          // if (response.data.code === 200) {
          //   //console.log(response.data);
          //   this.$message.success("提交成功");
          //   this.enterpriseForm = {
          //     companyName: "",
          //     industry: "",
          //     mainProducts: "",
          //     contactPerson: "",
          //     address: "",
          //     unitNature: "",
          //     unitType: "",
          //     mainCustomerGroup: "",
          //     phoneNumber: "",
          //     socialCreditCode: "",
          //   };
          //   this.dialogVisiblexinxi = false;
          //   this.dialogVisiblepay = true;
          //   this.$api
          //     .selectMyExampleOfPaymentInformation()
          //     .then((datas) => {
          //       console.log(datas);
          //       if (datas.length > 0) {
          //         this.bigdan = datas[0];
          //       } else {

          //       }
          //     })
          //     .catch((err) => {
          //       console.error("请求失败:", err);
          //     });

          // }
        } else {
          this.$message.warning("请填写完整信息");
          return false;
        }
      });
    },
    handleUploadSuccess(res, file) {
      // 假设服务器返回的数据里有图片url，比如 res.url
      file.url = res.data.url || URL.createObjectURL(file.raw);

      // 将文件对象加入fileList中（element-ui已经自动加了，这里主要是同步表单的数据）
      this.fileList = [res.data];

      // 把上传的图片url更新到form.uploadedImage以做回显或后续提交
      this.enterpriseForm.uploadedImage = res.data.url;
      //console.log(this.enterpriseForm);
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.enterpriseForm.uploadedImage = this.fileList.map((item) => item.url);
    },
    beforeRemove(file, fileList) {
      // 如果需要阻止删除可以return false，这里允许删除
      return true;
    },
    // 初始化时，如果form.uploadedImage中有旧图片可放入fileList，用于回显
    //  initFileList() {
    //   if (this.enterpriseForm.uploadedImage && this.enterpriseForm.uploadedImage.length > 0) {
    //     this.fileList = this.enterpriseForm.uploadedImage.map((url, index) => ({
    //       name: `image_${index}`,
    //       url,
    //       status: 'success',
    //     }));
    //   }
    // },
    handlePictureCardPreview(file) {
      window.open(file.url);
    },
    getOneYearLaterDate() {
      // 创建当前日期的副本（避免修改原始对象）
      const currentDate = new Date();
      const oneYearLater = new Date(currentDate);

      // 增加一年
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);

      // 格式化日期
      const year = oneYearLater.getFullYear();
      const month = String(oneYearLater.getMonth() + 1).padStart(2, "0");
      const day = String(oneYearLater.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    nbmthos() {
      this.needDate = this.getOneYearLaterDate();
      const userId = localStorage.getItem("userId");
      this.$api
        .getUserInfo({
          userId: userId,
        })
        .then((responses) => {
          if (responses) {
            let amm = responses.phonenumber;
            this.needPhonenumber = amm;
          }
        });

      this.$api
        .weChatPayordering({
          userId: userId,
        })
        .then((response) => {
          if (response) {
            // this.urlspay = response;
            // const codeUrl = this.urlspay;
            const codeUrl = this.decrypt(response.code_url, this.encodeFactor);
            const OutTradeNo = this.decrypt(
              response.OutTradeNo,
              this.encodeFactor
            );
            console.log(codeUrl)
            this.$api
              .weChatPayconfirm({
                OutTradeNo: OutTradeNo,
                codeUrl: codeUrl,
              })
              .then((responses) => {
                if (responses) {
                 console.log(responses)
                  if(responses=='true'){
          
                  }
                }
              });
      
       this.startPolling(OutTradeNo);
this.$nextTick(() => {
              this.generateWechatQR(codeUrl);
            });
            
          }
        });
    },
    stopPolling() {
      // 停止定时器
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    startPolling(OutTradeNo) {
      // 启动定时器
      this.timer = setInterval(() => {
        this.$api
          .weChatPayStausQuery({
            OutTradeNo: OutTradeNo,
          })
          .then((response) => {
            if (response) {
              console.log("获取到的数据：", response);
              if (response == 0) {
                return;
              } else if (response == 1) {
                this.payVisible=false
                this.stopPolling();
                this.getintmetion();
                this.$message.success(`支付成功`);
              }
              // 在这里可以对获取到的数据进行处理
            }
          })
          .catch((error) => {
            console.error("请求出错：", error);
          });
      }, 3000);
    },
    // 每三秒调用一次fetchData函数

    async subscribe(planType, ID) {
      // this.dialogVisiblepay = true;
       if (this.debounceTimer) clearTimeout(this.debounceTimer);
  
  // 设置新的防抖定时器
  this.debounceTimer = setTimeout(async () => {
      this.planid = ID;
      console.log(planType);
      if (planType == "personal") {
        this.nbmthos();
         
        setTimeout(() => {
          this.payVisible = true;
        }, 400);

        
      } else {
        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        this.needlevel = this.getPlanName(planType) + "会员";
        this.getCardListDatas();
        this.$api
          .selectOrderCompanyInfo({
            userId: userId,
          })
          .then((responses) => {
            if (responses.length > 0) {
              //console.log(response.data);
              this.dialogVisiblexinxi = true;
              this.enterpriseForm = responses[0];
              if (this.enterpriseForm.uploadedImage != "") {
                this.fileList = [
                  {
                    url: this.enterpriseForm.uploadedImage,
                    name: this.enterpriseForm.update || "未命名文件", // 默认值
                  },
                ];
              } else {
                this.fileList = [];
              }
            } else {
              this.dialogVisiblexinxi = true;
            }
          });
        // const responsem = await this.axios.get(
        //   `https://www.hittik.com/zntop/orderForMemberController/selectOrderCompanyInfo?userId=${userId}`,

        //   config
        // );

        // if (responsem.data.code === 200) {
        //   if (responsem.data.data.length > 0) {
        //     this.dialogVisiblexinxi = true;
        //     this.enterpriseForm = responsem.data.data[0];
        //     if (this.enterpriseForm.uploadedImage != "") {
        //       this.fileList = [
        //         {
        //           url: this.enterpriseForm.uploadedImage,
        //           name: this.enterpriseForm.update || "未命名文件", // 默认值
        //         },
        //       ];
        //     } else {
        //       this.fileList = [];
        //     }
        //   } else {
        //     this.dialogVisiblexinxi = true;
        //   }
        // }
        // 这里可以添加开通会员的逻辑
      }
    },900)
    },
    getPlanName(type) {
      const names = {
        personal: "个人",
        enterprise: "企业",
        premium: "高级",
      };
      return names[type] || "";
    },

    applyInvoice(order) {
      this.$message.success(`正在为订单 ${order.orderNumber} 申请发票`);
      // 这里可以添加发票申请逻辑
      this.dialogVisiblefa = true;
    },
    deleteOrder(order) {
      this.$confirm(`确定要删除订单 ${order.orderNumber} 吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$api
          .deleteOrderFor({
            id: order.id,
          })
          .then((responses) => {
            if (responses) {
              this.$message.success("删除成功");

              this.getintmetions();
            }
          });
        //   const response = await this.axios.get(
        //     `https://www.hittik.com/zntop/orderForMemberController/deleteOrderFor?id=${order.id}`,
        //     config
        //   );
        //   if (response.data.code === 200) {
        //     //console.log(response.data);
        //     this.$message.success("删除成功");

        //     this.getintmetions();
        //   }
      });
      // .catch(() => {
      //   this.$message.info("已取消删除");
      // });
    },

    async handleClick(row) {
      //console.log(row);

      this.dialogVisiblepay = true;

      const userId = localStorage.getItem("userId");

      let obj = {
        userId: userId,
        standby: row.membershipLevel,
      };

      this.$api.orderForMemberController(obj).then((response) => {
        if (response) {
          this.paymentForm = response;
        }
      });
      // const responseo = await this.axios.post(
      //   `https://www.hittik.com/zntop/orderForMemberController/selectMyPaymentVoInfo`,
      //   obj,
      //   config
      // );
      // if (responseo.data.code === 200 && responseo.data.data) {
      //   //console.log(responseo.data);
      //   this.paymentForm = responseo.data.data;
      // }

      this.$api.getTitle().then((responses) => {
        if (responses) {
          const newdata = responses.enterprisePicture;
          this.srcList = newdata[0]
            .split(",")
            .map((item) => item.trim())
            .reverse();
          this.srcurl = this.srcList[0];

          const newdatatwo = responses.enterpriseQrCode;
          const overdata = newdatatwo[0].split(",").map((item) => item.trim());
          this.urlimageList = [overdata[0]];
          this.urlimage = overdata[1];
        }
      });
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (row.showCategory) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    // 单元格样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 && row.showCategory) {
        return {
          background: "#E9F5FF",
          color: "#2289FE",
          fontWeight: "400",
          fontSize: "16px",
          textAlign: "center",
          border: "3px #fff solid",
        };
      }
      // 斑马纹效果
      if (rowIndex % 2 === 1 && columnIndex !== 0) {
        return {
          background: "#f9f9f9",
        };
      }
    },
    handleCascaderChange(value) {
      console.log("选中的值:", value);
    },
    async handleChange(value) {
      // value 是当前开关的值，即 "1" 或 "0"
      //console.log("Switch value changed to:", value);
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      this.$api
        .getEmail({
          userId: userId,
          email: value,
        })
        .then((responses) => {
          if (responses == "0") {
            //console.log(response.data);
            this.needemial = false;
            this.$message({
              message: "邮件每周推送!",
              type: "success", // 可选类型：success、warning、info、error
            });
          } else {
            if (responses.msg == "2") {
              this.needemial = false;
            } else {
              this.needemial = true;
              this.$message({
                message: "请先设置邮箱!",
                type: "warning", // 可选类型：success、warning、info、error
              });
            }
          }
        });
      // const response = await this.axios.get(
      //   `https://www.hittik.com/zntop/top/getEmail?userId=${userId}&&email=${value}`,
      //   config
      // );

      // if (response.data.code === 200) {
      //   this.needemial = false;
      //   this.$message({
      //     message: "邮件每周推送!",
      //     type: "success", // 可选类型：success、warning、info、error
      //   });
      // } else {
      //   if (response.data.msg == "2") {
      //     this.needemial = false;
      //   } else {
      //     this.needemial = true;
      //     this.$message({
      //       message: "请先设置邮箱!",
      //       type: "warning", // 可选类型：success、warning、info、error
      //     });
      //   }
      // }
    },
    submitAddMemberForm() {
      this.$refs.addMemberForm.validate((valid) => {
        if (valid) {
          // alert('表单验证通过');
          const token = localStorage.getItem("token");

          const config = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };

          // const url = "https://www.hittik.com/znauth/register";
          this.$api.register(this.addMemberForm).then((response) => {
            if (response) {
              this.$message({
                message: "注册成功",
                type: "success", // 可选类型：success、warning、info、error
              });

              this.$api.login(this.addMemberForm).then((response) => {
                if (response) {
                  const userId = localStorage.getItem("userId");

                  const userIds = response.userid;
                  let needdata = {
                    userId: userId,
                    userIds: userIds,
                    company: this.companyId,
                    amount: this.addMemberForm.quota,
                  };

                  this.$api.insertCompany(needdata).then((response) => {
                    if (response) {
                      this.addMemberVisible = false;
                      this.$message.success("添加成功");

                      let daa = { name: "memberManage" };
                      this.handleTabClick(daa);
                    }
                  });
                }
              });
            } else if (response.includes("注册账号已存在")) {
              this.$store.commit("setUseisRegister", false);
            }
          });
          //   this.axios
          //     .post(url, this.addMemberForm)
          //     .then((response) => {
          //       // 请求成功，处理响应数据
          //       if (response.data.code === 200) {
          //         //console.log(response);

          //         const url = "https://www.hittik.com/znauth/login";
          //         this.axios
          //           .post(url, this.addMemberForm)
          //           .then(async (response) => {
          //             // 请求成功，处理响应数据
          //             if (response.data.code === 200) {
          //               // const responsem = await this.axios.post(
          //               //   `https://www.hittik.com/zntop/MemberCenter/insertCompany`,
          //               //   needdata,
          //               //   config
          //               // );
          //               // if (responsem.data.code === 200) {
          //               //   this.addMemberVisible = false;
          //               //   this.$message.success("添加成功");
          //               //   let daa = { name: "memberManage" };
          //               //   this.handleTabClick(daa);
          //               // } else {
          //               //   this.$message({
          //               //     message: responsem.data.msg,
          //               //     type: "error", // 可选类型：success、warning、info、error
          //               //   });
          //               // }
          //             } else {
          //               this.$message({
          //                 message: response.data.msg,
          //                 type: "error", // 可选类型：success、warning、info、error
          //               });
          //               console.error("Error:", response);
          //             }
          //           })
          //           .catch((error) => {
          //             // 请求失败，处理错误
          //             console.error("Error:", error);
          //           });
          //       } else {
          //         if (response.data.msg.includes("注册账号已存在")) {
          //           this.$store.commit("setUseisRegister", false);
          //         }

          //         this.$message({
          //           message: response.data.msg,
          //           type: "error", // 可选类型：success、warning、info、error
          //         });
          //       }
          //     })
          //     .catch((error) => {
          //       // 请求失败，处理错误
          //       console.error("Error:", error);
          //     });
        } else {
          //console.log("验证失败");
          return false;
        }
      });
    },
    editUserInfo() {
      this.$refs.userInfoForm.validate(async (valid) => {
        if (valid) {
          // 处理用户信息的修改逻辑
          //console.log("用户信息已修改", this.userInfo);

          try {
            // 假设 token 存储在 localStorage 中
            const token = localStorage.getItem("token");

            const config = {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            };
            const membershipLevelsReverse = {
              免费会员: 1,
              VIP: 3,
              超级VIP: 4,
            };

            // 将用户输入的会员等级转换为数字
            if (
              membershipLevelsReverse[this.userInfo.membershiplevel] !==
              undefined
            ) {
              this.userInfo.membershiplevel =
                membershipLevelsReverse[this.userInfo.membershiplevel];
            } else {
              this.userInfo.membershiplevel = null; // 或者根据需求设置为其他值
            }

            // 请求数据
            const data = this.userInfo;

            this.$api.updateUserInfo(data).then((response) => {
              if (response) {
                this.$message({
                  message: "信息修改成功",
                  type: "success", // 可选类型：success、warning、info、error
                });
                this.gotoMsg();
              }
            });
            // 发起请求
            // const response = await this.axios.put(
            //   "https://www.hittik.com/znsystem/weixin/updateUserInfo",
            //   data,
            //   config
            // );

            // if (response.data.code === 200) {
            //   this.$message({
            //     message: "信息修改成功",
            //     type: "success", // 可选类型：success、warning、info、error
            //   });
            //   this.gotoMsg();
            // } else {
            //   this.$message({
            //     message: response.data.msg,
            //     type: "error", // 可选类型：success、warning、info、error
            //   });
            // }

            // 处理响应
            //console.log(response.data);
          } catch (error) {
            // 处理错误
            console.error("请求失败:", error);
            alert("密码修改失败，请检查网络或联系管理员");
          }
        } else {
          //console.log("验证失败");
          return false;
        }
      });
    },
    toggleOriginalPasswordView() {
      this.originalPasswordType =
        this.originalPasswordType === "password" ? "text" : "password";
    },
    toggleNewPasswordView() {
      this.newPasswordType =
        this.newPasswordType === "password" ? "text" : "password";
    },
    toggleConfirmPasswordView() {
      this.confirmPasswordType =
        this.confirmPasswordType === "password" ? "text" : "password";
    },
    formatDate(date) {
      // 获取年、月、日
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，需要加 1
      const day = String(date.getDate()).padStart(2, "0"); // 日
      // 返回格式化后的日期
      return `${year}-${month}-${day}`;
    },
    refeash() {
      this.getCardListData();
    },
    async getCardListData() {
      // const res = await this.axios.get(
      //   "http://123.60.38.210:9205/top/getSubscriber"
      // );
      const token = localStorage.getItem("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      // const res = await this.axios.get(
      //   "https://www.hittik.com/zntop/top/getSubscriber",
      //   config
      // );

      this.$api.getSubscriber().then((responses) => {
        if (responses) {
          //console.log(response.data);
          const newsList = responses;
          this.allSeletdata = JSON.parse(JSON.stringify(responses));
          this.subscriptionOptions = newsList.map((item) => ({
            label: item.subscriberName,
            value: item.id,
          }));
          if (newsList.length > 0) {
            this.selectedSubscription = newsList[0].id;
            this.search();
          }
        }
      });

      //console.log(newsList);
    },
    saves() {
      //console.log("保存m", this.forms);
      this.$refs.formRefss.validate(async (valid) => {
        if (valid) {
          //console.log("保存", valid);
          const uid = localStorage.getItem("userId");
          this.forms.userId = uid;
          const token = localStorage.getItem("token");

          const config = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };

          this.$api.addSubscriber(this.forms).then((response) => {
            if (response) {
              this.$message({
                message: "保存成功",
                type: "success", // 可选类型：success、warning、info、error
              });

              this.getCardListData();
            } else {
              this.$message({
                message: "保存失败",
                type: "success", // 可选类型：success、warning、info、error
              });
              this.dialogVisible = false;
            }
          });
          // const url = "https://www.hittik.com/zntop/top/addSubscriber";
          // this.axios
          //   .post(url, this.forms, config)
          //   .then((response) => {
          //     // 请求成功，处理响应数据
          //     //console.log("Success:", response.data);
          //     this.$message({
          //       message: "保存成功",
          //       type: "success", // 可选类型：success、warning、info、error
          //     });

          //     this.getCardListData();
          //   })
          //   .catch((error) => {
          //     // 请求失败，处理错误
          //     console.error("Error:", error);
          //     this.$message({
          //       message: "保存失败",
          //       type: "success", // 可选类型：success、warning、info、error
          //     });
          //   });
          // this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    async gotoMsg() {
      try {
        const token = localStorage.getItem("token");
        // if (!token) {
        //   throw new Error('No token');
        // }
        // 设置请求头，携带 token
        const userId = localStorage.getItem("userId");

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        this.$api
          .getUserInfo({
            userId: userId,
          })
          .then((responses) => {
            if (responses) {
              //console.log(response.data);
              this.userInfo = responses;
              const membershipLevels = {
                1: "免费会员",
                3: "VIP",
                4: "超级VIP",
              };
              if (membershipLevels[this.userInfo.membershiplevel]) {
                this.userInfo.membershiplevel =
                  membershipLevels[this.userInfo.membershiplevel];
              } else {
                this.userInfo.membershiplevel = "未知等级"; // 如果返回的值不在映射中，设置为“未知等级”
              }
            }
          });
        // const response = await this.axios.get(
        //   `https://www.hittik.com/znsystem/weixin/getUserInfo?userId=${userId}`,
        //   config
        // );

        // if (response.data.code === 200) {

        //   // this.$message({
        //   //     message: "密码修改成功",
        //   //     type: "success", // 可选类型：success、warning、info、error
        //   //   });
        // } else {
        //   this.$message({
        //     message: response.data.msg,
        //     type: "error", // 可选类型：success、warning、info、error
        //   });
        // }

        // 处理响应
        //console.log(response.data);
      } catch (error) {
        // 处理错误
        console.error("请求失败:", error);
      }
    },

    tablechange(id) {
      //console.log(id);

      this.activeTab = id;
      this.gotoMsg();
      if (id === "user") {
        this.getintmetion();
      } else if (id === "payer") {
        this.getintmetions();
        this.getneeddata();
      }
    },

    async getintmetions() {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      this.$api
        .getOrderFor({
          userId: userId,
        })
        .then((responses) => {
          if (responses.length > 0) {
            //console.log(response.data);
            let needdata = responses;

            this.orders = needdata;
          }
        });
      // const response = await this.axios.get(
      //   `https://www.hittik.com/zntop/orderForMemberController/getOrderFor?userId=${userId}`,
      //   config
      // );
      // if (response.data.code === 200) {
      //   //console.log(response.data);
      //   let needdata = response.data.data;

      //   this.orders = needdata;
      // }
      this.$api
        .selectMyExampleOfPaymentInformation()
        .then((datas) => {
          console.log(datas);
          if (datas.length > 0) {
            this.bigdan = datas[0];
          } else {
            // this.bigdan = {};
          }
        })
        .catch((err) => {
          console.error("请求失败:", err);
        });
    },
    async getintmetion() {
      const token = localStorage.getItem("token");
      const id = localStorage.getItem("userId");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      var needdatas = "";

      this.$api
        .selectAccount({
          userId: id,
        })
        .then((responses) => {
          if (responses) {
            //console.log(response.data);
            needdatas = responses.title;
          }
        });
      // const responsem = await this.axios.get(
      //   `https://www.hittik.com/zntop/MemberCenter/selectAccount?userId=${id}`,
      //   config
      // );
      // if (responsem.data.code === 200 && responsem.data.data) {
      //   needdatas = responsem.data.data.title;
      // }

      this.$api.getMemberList().then((responses) => {
        if (responses) {
          let needdata = responses;
          needdata.membershipPlans.forEach((item) => {
            if (item.title === needdatas) {
              item.status = "已开通";
            }
          });
          this.membershipPlans = needdata.membershipPlans.map((item) => {
            // 将rowspan转换为数字类型

            // 将showCategory转换为布尔值
            item.discount = item.discount === "true";
            return item;
          });

          this.tableData = needdata.tableData.map((item) => {
            // 将rowspan转换为数字类型
            item.rowspan = Number(item.rowspan);
            // 将showCategory转换为布尔值
            item.showCategory = item.showCategory === "true";
            return item;
          });
        }
      });
      // const response = await this.axios.get(
      //   `https://www.hittik.com/zntop/MemberCenter/getMemberList`,
      //   config
      // );
      // if (response.data.code === 200) {
      //   //console.log(response.data);

      // }
    },
    deleteSubscription() {
      if (this.selectedSubscription == "") {
        this.$message({
          message: "请选择订阅器",
          type: "error", // 可选类型：success、warning、info、error
        });

        // yzmessage.error('')
      } else {
        const token = localStorage.getItem("token");

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        const matchingItem = this.allSeletdata.find(
          (item) => item.id === this.selectedSubscription
        );
        const url = `https://www.hittik.com/zntop/top/deleteSubscriber?id=${matchingItem.id}`;

        // 要删除的订阅者信息（根据接口要求传递参数）
        // const subscriberId = '12345'; // 示例参数，根据实际情况调整

        // 使用 this.$message.confirm 来显示确认对话框
        this.$confirm("确认删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$api
              .deleteSubscriber({
                id: matchingItem.id,
              })
              .then((responses) => {
                if (responses) {
                  this.$message({
                    message: "删除成功",
                    type: "success", // 可选类型：success、warning、info、error
                  });

                  this.getCardListData();
                  this.selectedSubscription = "";
                }
              });
            //   this.axios
            //     .delete(url, config)
            //     .then((response) => {
            //       if (response.status == 200)
            //         this.$message({
            //           message: "删除成功",
            //           type: "success", // 可选类型：success、warning、info、error
            //         });

            //       this.getCardListData();
            //       this.selectedSubscription = "";
            //     })
            //     .catch((error) => {
            //       this.$message({
            //         message: "删除失败",
            //         type: "error", // 可选类型：success、warning、info、error
            //       });
            //       if (error.response) {
            //         console.error("响应状态码:", error.response.status);
            //         console.error("响应数据:", error.response.data);
            //       } else if (error.request) {
            //         console.error("请求未收到响应:", error.request);
            //       } else {
            //         console.error("请求配置错误:", error.message);
            //       }
            //     });
          })
          .catch(() => {
            // 用户点击取消按钮时执行的操作
            //console.log("用户取消删除");
          });
      }
    },
    modifyConditions() {
      if (this.selectedSubscription === "") {
        this.$message({
          message: "请选择订阅器",
          type: "error", // 可选类型：success、warning、info、error
        });
        this.dialogVisible = false;
      } else {
        const matchingItem = this.allSeletdata.find(
          (item) => item.id === this.selectedSubscription
        );

        if (matchingItem) {
          this.forms = matchingItem;
          setTimeout(() => {
            this.dialogVisible = true;
          }, 500);
        }
      }
    },
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const uid = localStorage.getItem("userId");
          this.form.userId = uid;
          const token = localStorage.getItem("token");

          const config = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };
          const url = "https://www.hittik.com/zntop/top/addSubscriber";
          this.$api.addSubscriber(this.form).then((response) => {
            if (response) {
              this.$message({
                message: "保存成功",
                type: "success", // 可选类型：success、warning、info、error
              });
              this.needemial = false;
            } else {
            }
            this.getCardListData();
          });
          // this.axios
          //   .post(url, this.form, config)
          //   .then((response) => {
          //     // 请求成功，处理响应数据

          //     if (response.data.code == 200) {
          //       this.$message({
          //         message: "保存成功",
          //         type: "success", // 可选类型：success、warning、info、error
          //       });
          //       this.needemial = false;
          //     } else {
          //       const errorMessage = response.data.msg || "未知错误";

          //       this.$message({
          //         message: errorMessage,
          //         type: "error", // 可选类型：success、warning、info、error
          //       });
          //     }
          //     this.getCardListData();
          //   })
          //   .catch((error) => {
          //     // 请求失败，处理错误
          //     console.error("Error:", error);
          //     this.$message({
          //       message: "保存失败",
          //       type: "success", // 可选类型：success、warning、info、error
          //     });
          // });
        } else {
          return false;
        }
      });
    },
    cancel() {
      //console.log("取消");
    },

    updatePassword() {
      this.$refs.passwordFormRef.validate(async (valid) => {
        if (valid) {
          // alert('密码修改成功');
          // 在这里可以调用修改密码的 API

          try {
            // 假设 token 存储在 localStorage 中
            const token = localStorage.getItem("token");
            // if (!token) {
            //   throw new Error('No token');
            // }
            // 设置请求头，携带 token
            const config = {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            };

            // 请求数据
            const data = {
              oldPassword: this.passwordForm.originalPassword,
              newPassword: this.passwordForm.newPassword,
            };
            this.$api.updatePwd(data).then((response) => {
              if (response) {
                this.$message({
                  message: "密码修改成功",
                  type: "success", // 可选类型：success、warning、info、error
                });
              }
            });
            // 发起请求
            //   const response = await this.axios.put(
            //     "https://www.hittik.com/znsystem/user/profile/updatePwd",
            //     data,
            //     config
            //   );

            //   if (response.data.code === 200) {
            //     this.$message({
            //       message: "密码修改成功",
            //       type: "success", // 可选类型：success、warning、info、error
            //     });
            //   } else {
            //     this.$message({
            //       message: response.data.msg,
            //       type: "error", // 可选类型：success、warning、info、error
            //     });
            //   }

            //   // 处理响应
          } catch (error) {
            // 处理错误

            this.$message({
              message: "密码修改失败，请检查网络或联系管理员",
              type: "error", // 可选类型：success、warning、info、error
            });
          }
        } else {
          // alert('表单验证失败');
        }
      });
    },

    search() {
      let form = {
        subscriberId: this.selectedSubscription,
        name: this.searchKeyword,
        updateTime: this.currentDate,
        pageNum: this.currentPage,
        areaName: this.selectedProvince,
        pageSize: 6,
      };
      const token = localStorage.getItem("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      this.$api.getSubscriberPageInfo(form).then((response) => {
        if (response) {
          this.dataList = response.list;
          this.totalall = response.total;
        } else {
          this.$message({
            message: "保存失败",
            type: "success", // 可选类型：success、warning、info、error
          });
        }
      });
      // const url = "https://www.hittik.com/zntop/top/getSubscriberPageInfo";
      // this.axios
      //   .post(url, form, config)
      //   .then((response) => {
      //     // 请求成功，处理响应数据
      //     //console.log("Success:", response.data);
      //     if (response.status == 200) {
      //       this.dataList = response.data.data.list;
      //       this.totalall = response.data.data.total;
      //     }

      //   })
      //   .catch((error) => {
      //     // 请求失败，处理错误
      //     console.error("Error:", error);
      //     this.$message({
      //       message: "保存失败",
      //       type: "success", // 可选类型：success、warning、info、error
      //     });
      //   });
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.search();
    },

    handleDetail(item) {
      // 在这里添加查看详情的逻辑
    },

    unbindWeixin() {},

    async getCardListDatanew() {
      this.$api
        .getSection({
          parentId: 0,
        })
        .then((responses) => {
          if (responses) {
            const newsList = responses;
            const processItems = (
              list,
              labelProperty,
              valueProperty,
              targetArray
            ) => {
              list.forEach((item) => {
                if (item[labelProperty] && item[valueProperty]) {
                  targetArray.push({
                    label: item[labelProperty],
                    value: item[valueProperty],
                  });
                }
              });
            };

            // 使用通用函数处理不同列表
            processItems(newsList.area, "districtName", "id", this.regions);
            processItems(
              newsList.section,
              "fieldName",
              "id",
              this.fieldOptions
            );
          }
        });
      // const res = await this.axios.get(
      //   "https://www.hittik.com/zntop/top/getSection?parentId=0"
      // );

      // const newsList = res.data.data;
      // const processItems = (
      //   list,
      //   labelProperty,
      //   valueProperty,
      //   targetArray
      // ) => {
      //   list.forEach((item) => {
      //     if (item[labelProperty] && item[valueProperty]) {
      //       targetArray.push({
      //         label: item[labelProperty],
      //         value: item[valueProperty],
      //       });
      //     }
      //   });
      // };

      // // 使用通用函数处理不同列表
      // processItems(newsList.area, "districtName", "id", this.regions);
      // processItems(newsList.section, "fieldName", "id", this.fieldOptions);
    },
  },
  mounted() {
    this.getCardListData();
    this.getCardListDatanew();

    // 检测路由参数
    const { action } = this.$route.query;
    console.log(action, "action");
    if (action === "openMembership") {
      // 调用 tablechange 方法
      this.tablechange("user");
    } else if (action == "buyer") {
      this.tablechange("user");
    }
  },
};
</script>

<style scoped lang="scss">
.newstions {
  font-size: 20px;
  /* font-style: unset; */
  font-weight: 600;
  /* margin: 50px; */
  /* padding: 10px; */
  margin-top: -17px;
  margin-bottom: 20px;
}

.payment-container {
  width: 800px; /* 与设计稿宽度匹配 */
  margin: 40px auto;
}

/* 卡片样式（粉色边框） */
.payment-card {
  border: 1px solid #ff8f8f;
  border-radius: 8px;
  padding: 40px;
  width: 80%;
  margin-left: 10%;
  background: #fffefe;
  display: flex;
  align-items: center;
}

/* 二维码区域 */
.qrcode-box {
  width: 150px;
  height: 150px;
  position: relative;

  border: 1px solid #dcdfe6;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 100px;
  /* padding-right: 20px; */
  margin-right: 43px;
}

.qrcode-img {
  width: 100px;
  height: 100px;
}

/* 加载态（可选） */
.qrcode-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  color: #999;
}

/* 信息内容区 */
.info-section {
  display: flex;
  flex-direction: column;
}

/* 标题行 */
.title-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.title-icon {
  color: #ff4d4f; /* 红色对勾 */
  font-size: 20px;
  margin-right: 6px;
}

.title-tag {
  color: #ff4d4f;
  font-size: 16px;
  font-weight: bold;
  margin-right: 8px;
}
.title-img {
  width: 24px;
  height: 24px;
}
.title-imgs {
  width: 24px;
  height: 20px;
}

.title-text {
  color: #333;
  font-size: 16px;
  font-weight: bold;
}

/* 实付信息行 */
.pay-info {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.pay-label {
  color: #999;
  margin-right: 4px;
}

.pay-amount {
  color: #ff4d4f;
  font-size: 18px;
  font-weight: bold;
}

.pay-method {
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.method-icon {
  color: #67c23a; /* 绿色对勾 */
  font-size: 18px;
  margin-right: 6px;
}

/* 倒计时 */
.countdown {
  color: #999;
  font-size: 14px;
  margin-bottom: 8px;
}

/* 协议提示 */
.agreement {
  color: #999;
  font-size: 14px;
}

.agreement-link {
  color: #409eff;
  text-decoration: none;
}
.agreement-link:hover {
  text-decoration: underline;
}

.payment-dialog {
  .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #ebeef5;
  }
  .el-dialog__title {
    font-size: 16px;
    font-weight: 700;
  }
  .el-dialog__body {
    padding: 20px;
  }
}

/* 订单详情区 */

.order-detail {
  display: flex;
  flex-direction: column;

  width: 80%;
  margin-left: 10%;
  padding: 50px;
  background: #fffefd;
  border: 1px solid #fde6cc;
  border-radius: 8px;

  margin-bottom: 20px;
}
.orders-detail {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

  width: 100%;
}

.orders-detail p {
  margin: 0;
  color: #333;
  font-size: 14px;
  text-align: left;
}

.page-container {
  padding: 20px;
}

/* 新增成员弹框样式 */
.verify-code-wrapper {
  display: flex;
}

.send-btn {
  margin-left: 10px;
  width: 120px;
}

/* 消费明细弹框样式 */
.filter-bar {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.date-picker {
  width: 150px;
}

.to-text {
  margin: 0 10px;
  font-size: 14px;
}

.pagination {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.total {
  margin-right: 20px;
  font-size: 14px;
}
.el-tab-pane {
  .company-info {
    padding: 20px;
    background: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 20px;

    > div {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      gap: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      .el-tag {
        height: 24px;
        line-height: 22px;
        font-size: 12px;
        &--success {
          background-color: #f0f9eb;
          border-color: #e1f3d8;
          color: #67c23a;
        }
      }

      .admin-label {
        color: #606266;
        font-size: 13px;
      }

      .el-button {
        margin-left: 10px;
        &--mini {
          padding: 5px 11px;
        }
      }

      .el-tag--info {
        background-color: #f4f4f5;
        border-color: #e9e9eb;
        color: #909399;
      }
    }

    .action-buttons {
      .el-button {
        padding: 6px 12px;
        &--danger {
          background-color: #f56c6c;
          border-color: #f56c6c;
        }
      }
    }
  }

  .el-table {
    border: 1px solid #ebeef5;
    border-radius: 4px;

    th {
      background-color: #fafafa;
      color: #606266;
      font-weight: 500;
    }

    td {
      color: #606266;
    }

    .el-button--text {
      margin-left: 8px;
      color: #409eff;
      &.is-disabled {
        color: #c0c4cc;
      }
    }

    .el-button[style*="color: #f56c6c"] {
      color: #f56c6c !important;
      &:hover {
        color: #f78989 !important;
      }
    }
  }

  .el-dialog {
    .el-input-number {
      width: 180px;
      margin-right: 8px;
    }

    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      margin-top: 20px;
    }
  }
}

.dialog-footer {
  text-align: right;
}

/* New styles for two-column layout */
.two-column-form {
  display: flex;
  flex-wrap: wrap;
}

.two-column-form .el-form-item {
  flex: 1 1 40%; /* Allows items to span about half the container */
  margin-right: 20px; /* Adds some space between columns */
}

/* Remove margin on the last item in each row */
.two-column-form .el-form-item:nth-child(odd) {
  margin-right: 20px; /* Remove right margin for odd items */
}

.order-payment-container {
  padding: 20px;
  font-family: Arial, sans-serif;
}

.unpaid {
  color: #f56c6c;
  font-weight: bold;
}

.el-table {
  margin-top: 20px;
}

.el-table td,
.el-table th {
  padding: 12px 0;
}

.payment-content {
  padding: 20px;
}

.bank-info {
  margin: 20px 0;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.bank-info p {
  margin: 10px 0;
  line-height: 1.6;
}

.notice {
  margin-top: 30px;
}

.notice h4 {
  margin-bottom: 15px;
  color: #606266;
}

.notice ol {
  padding-left: 20px;
}

.notice li {
  margin-bottom: 10px;
  line-height: 1.6;
}

.membership-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 20px;
}

.membership-card {
  border-radius: 4px;
  padding: 20px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  height: 100%;
  border-top: 4px solid #eee;
  position: relative;
}

.membership-card.free {
  border-top-color: #999;
}

.membership-card.personal {
  border-top-color: #4aab0e;
}

.membership-card.enterprise {
  border-top-color: #ea9514;
}

.membership-card.premium {
  border-top-color: #db3713;
}

.membership-title {
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 8px 0;
  text-align: center;
  position: relative;
  display: inline-block;
}

.discount-tag {
  position: absolute;
  top: -10px;
  right: -40px;
  font-size: 12px;
  background-color: #ff6b00;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: normal;
}

.app-tag {
  font-size: 14px;
  color: #666;
  margin: -8px 0 12px 0;
  text-align: center;
}

.membership-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  text-align: center;
}

.price-container {
  text-align: center;
  margin-bottom: 12px;
}

.price {
  font-size: 24px;
  font-weight: bold;
  color: #ff6b00;
}

.original-price {
  font-size: 16px;
  color: #999;
  text-decoration: line-through;
  margin-left: 8px;
}

.h1-coins {
  font-size: 14px;
  color: #333;
  margin-bottom: 16px;
  text-align: center;
  font-weight: 500;
}

.features {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 16px 0;
  padding-left: 18px;
}

.features li {
  margin-bottom: 8px;
}

.description {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 16px;
  text-align: center;
}

.action-area {
  margin-top: auto;
  text-align: center;
}

.status {
  font-size: 14px;
  color: #67c23a;
  margin-bottom: 12px;
  font-weight: 500;
}

.subscribe-btn {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border-radius: 4px;
}

.disabled-btn {
  background-color: #999;
  border-color: #999;
  cursor: not-allowed;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .membership-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .membership-container {
    grid-template-columns: 1fr;
  }
}

/* button {
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #ff4d4f;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #e04343;
} */

.container {
  display: flex;
  /* padding: 200px; */
  height: 100vh;
  /* padding: 102px 334px; */
  padding-top: 102px;
  padding-right: 334px;
  padding-bottom: 10px;
  padding-left: 334px;

  background: #f6f8fb;
  font-family: Source Han Sans CN;
}
.newslact {
  width: 219px;
}

.sidebar {
  width: 220px;
  background-color: #ffff;
  padding: 20px;
}

.newstion {
  border: 1px solid #d2dadf;
  border-radius: 0.26042vw;
  padding: 19px;
  height: 190px;
  /* display: flex;
  flex-direction: row; */
}

.nav {
  list-style: none;
  padding: 0;
}
.data-list-container {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.total {
  font-size: 14px;
  color: #333;
}

.sort-buttons {
  display: flex;
}

.data-items {
  width: 100%;
}

.data-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
}

.data-item:last-child {
  border-bottom: none;
}

.item-content {
  flex: 1;
}

.title {
  font-size: 16px;
  font-weight: normal; /*设置为normal*/
  color: #333;
  margin-bottom: 10px;
}

.details {
  font-size: 12px;
  color: #999;
}

.date {
  font-size: 12px;
  color: #999;
  white-space: nowrap;
}

.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 20px;
  box-sizing: border-box;
}

.pagination-info {
  font-size: 12px;
  color: #666;
}

.go-to-page {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666;
}
.newmain {
  background: #ffff;
  margin-left: 20px;
  width: 500px;
}
.search-form {
  margin-left: -100px;
}
.nav-item {
  margin-bottom: 10px;
  padding: 10px;

  border-radius: 5px;
  cursor: pointer;
  display: flex;
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0%;

  color: #676767;
}

.nav-item.active {
  color: #007bff;
  border-color: #007bff;
}

.el-header {
  background-color: #409eff;
  color: white;
  text-align: center;
  line-height: 60px;
}
.threestion {
  display: flex;
  flex-wrap: wrap;
  margin-left: 338px;
  margin-top: -61px;
}

.newdelect {
  position: absolute;
  right: 0;
  top: 5px;
}
.img-fluid {
  width: 28px;
  height: 28px;
  padding: 2px;
}
.newbutton {
  margin-left: 5px;
}

::v-deep.el-form-item__label {
  text-align: left !important;
  width: 100px !important;
}
.coins-text {
  color: #0478fd; /* 深蓝色 */
  font-weight: 500; /* 可选：如果需要加粗 */
}
.h1-icon {
  width: 16px;
  height: 16px;
  margin: 2px;
  /* margin-top: 5px; */
  margin-bottom: -3px;
}
.enterprise-dialog {
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.enterprise-dialog >>> .el-dialog__header {
  border-bottom: 1px solid #ebeef5;
  padding: 15px 20px;
}

.enterprise-dialog >>> .el-dialog__title {
  font-size: 16px;
  color: #303133;
  font-weight: bold;
}

.enterprise-dialog >>> .el-dialog__body {
  padding: 20px;
}

/* 表单容器 */
.form-container {
  width: 100%;
}

/* 表单行样式 */
.form-row {
  display: flex;
  margin-bottom: 18px;
}

/* 表单项样式 */
.form-item {
  flex: 1;
  margin-right: 20px;
  margin-bottom: 0;
}

.form-item:last-child {
  margin-right: 0;
}

.form-item.full-width {
  flex: 0 0 100%;
}

/* 标签样式 */
.form-item >>> .el-form-item__label {
  color: #606266;
  font-size: 14px;
  padding-right: 12px;
  line-height: 36px;
  text-align: right;
}

/* 输入框样式 */
.custom-input >>> .el-input__inner {
  height: 36px;
  line-height: 36px;
  border-radius: 2px;
  border: 1px solid #dcdfe6;
}

/* 选择器样式 */
.custom-select >>> .el-input__inner {
  height: 36px;
  line-height: 36px;
  border-radius: 2px;
  border: 1px solid #dcdfe6;
}

/* 上传组件样式 */
.custom-upload >>> .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border: 1px dashed #dcdfe6;
  border-radius: 2px;
}

.custom-upload >>> .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  border-radius: 2px;
}

/* 底部按钮样式 */
.dialog-footer {
  display: flex;
  justify-content: center;
  padding: 15px 20px;
  border-top: 1px solid #ebeef5;
}

.cancel-btn {
  padding: 10px 20px;
  border-radius: 2px;
  margin-right: 20px;
}

.submit-btn {
  padding: 10px 20px;
  border-radius: 2px;
  background-color: #1a3e72;
  border-color: #1a3e72;
}

.submit-btn:hover {
  background-color: #2c4f8b;
  border-color: #2c4f8b;
}

/* 弹框整体样式 */
.payment-dialog {
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.payment-dialog >>> .el-dialog__header {
  border-bottom: 1px solid #ebeef5;
  padding: 15px 20px;
}

.payment-dialog >>> .el-dialog__title {
  font-size: 16px;
  color: #303133;
  font-weight: bold;
}

.payment-dialog >>> .el-dialog__body {
  padding: 20px;
}

/* 支付信息容器 */
.payment-container {
  width: 100%;
}

/* 提示信息 */
.payment-tip {
  font-size: 14px;
  color: #606266;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.tip-number {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background-color: #1a3e72;
  color: white;
  border-radius: 50%;
  margin-right: 8px;
  font-size: 12px;
}

/* 收款账号信息 */
.account-info {
  background-color: #f5f7fa;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 20px;
}
.account-and-notice {
  display: flex;
  background-color: #f5f7fa;
  justify-content: space-between; /* 两边对齐 */
  margin-bottom: 20px; /* 可以调整边距 */
}

.account-info,
.notice-info {
  width: 48%; /* 可根据需要调整宽度 */
}

.info-title {
  font-size: 15px;
  color: #303133;
  margin: 0 0 12px 0;
  font-weight: bold;
}

.info-item {
  margin-bottom: 8px;
  font-size: 14px;
}

.info-label {
  color: #606266;
  display: inline-block;
  width: 98px;
}

.info-content {
  color: #303133;
}

/* 特别提示 */
.notice-info {
  margin-bottom: 25px;
}

.notice-title {
  font-size: 15px;
  color: #303133;
  margin: 0 0 12px 0;
  font-weight: bold;
}

.notice-list {
  padding-left: 20px;
  margin: 0 0 15px 0;
  font-size: 14px;
  color: #606266;
}

.notice-list li {
  margin-bottom: 8px;
  line-height: 1.5;
}

.contact-service {
  display: flex;
  align-items: center;
  color: #1a3e72;
  font-size: 14px;
  cursor: pointer;
}

.contact-text {
  margin-right: 5px;
}

.contact-icon {
  font-size: 16px;
}

/* 表单部分 */
.payment-form {
  margin-top: 20px;
}

.form-item {
  margin-bottom: 18px;
}

/* 标签样式 */
.form-item >>> .el-form-item__label {
  color: #606266;
  font-size: 14px;
  padding-right: 12px;
  line-height: 36px;
}

/* 输入框样式 */
.custom-input >>> .el-input__inner {
  height: 36px;
  line-height: 36px;
  border-radius: 2px;
  border: 1px solid #dcdfe6;
}

.example-text {
  font-size: 12px;
  color: #909399;
  margin-top: -47px;
  margin-left: 86px;
}

/* 底部按钮样式 */
.dialog-footer {
  display: flex;
  justify-content: center;
  padding: 15px 20;
}
.cancel-btn {
  padding: 10px 20px;
  border-radius: 2px;
  margin-right: 20px;
}

.submit-btn {
  padding: 10px 20px;
  border-radius: 2px;
  background-color: #1a3e72;
  border-color: #1a3e72;
}

.submit-btn:hover {
  background-color: #2c4f8b;
  border-color: #2c4f8b;
}
.login-code {
  position: relative;
  margin-left: 200px;
  margin-top: -46px;
}
.login-code-img {
  width: 109px;
  height: 45px;
}
</style>
